import { Drawer, Tooltip } from '@material-ui/core'
import React, { Fragment, useEffect, useRef, useState } from 'react'
import { Col, Nav, NavItem, NavLink, Row, TabContent, Table, TabPane } from 'reactstrap'
import { AsyncSearchableSelectHookForm, SearchableSelectHookForm, TextAreaHookForm, TextFieldHookForm } from '../layout/HookFormInputs'
import { Controller, useForm } from 'react-hook-form'
import NoContentFound from '../common/NoContentFound'
import { Assembly, BoughtOutPart, Component, EMPTY_DATA, FILE_URL, searchCount } from '../../config/constants'
import { useSelector, useDispatch } from 'react-redux'
import { getRawMaterialNameChild, getRMGradeSelectListByRawMaterial, getRMSpecificationDataAPI, getRMSpecificationDataList } from '../masters/actions/Material'
import { fetchSpecificationDataAPI } from '../../actions/Common'
import { getPartSelectListWtihRevNo } from '../masters/actions/Volume'
import { autoCompleteDropdownPart } from '../common/CommonFunctions'
import { reactLocalStorage } from 'reactjs-localstorage'
import { AttachmentValidationInfo, MESSAGES } from '../../config/message'
import classnames from 'classnames';
import redcrossImg from '../../assests/images/red-cross.png'

import { acceptAllExceptSingleSpecialCharacter, alphaNumeric, checkWhiteSpaces, decimalNumberLimit6, getFilteredDropdownOptions, getConfigurationKey, maxLength10, maxLength100, number, numberLimit6, Numeric, required, RFQ_KEYS, validateFileName, isPlantMultiSelectEnabled } from '../../helper'
import Button from '../layout/Button'
import HeaderTitle from '../common/HeaderTitle'
import { HAVELLSREMARKMAXLENGTH, REMARKMAXLENGTH } from '../../config/masterData'
import Dropzone from 'react-dropzone-uploader'
import LoaderCustom from '../common/LoaderCustom'
import Toaster from '../common/Toaster'
import { fileUploadQuotation, getAssemblyChildpart, getRfqPartDetails, setBopSpecificRowData, setRfqPartDetails, setRmSpecificRowData, setToolingSpecificRowData } from './actions/rfq'
import _ from 'lodash';
import { AgGridColumn, AgGridReact } from 'ag-grid-react';
import DatePicker from 'react-datepicker'
import DayTime from '../common/DayTimeWrapper';
import TooltipCustom from '../common/Tooltip'
import AddToolingRfq from './Tooling/AddToolingRfq'
import ToolingPartDetails from './Tooling/ToolingPartDetails'
const gridOptionsPart = {}
function ViewDrawer(props) {
    const dispatch = useDispatch()
    const dropzone = useRef(null);
    const isDeletingPlant = useRef(false); // Track delete operations to prevent useEffect interference

    const sopObjectTemp = [
        { sop: 'SOP1' },
        { sop: 'SOP2' },
        { sop: 'SOP3' },
        { sop: 'SOP4' },
        { sop: 'SOP5' },
    ]

    const { isOpen, anchor, isEditFlag, isViewFlag, AssemblyPartNumber, tableData, setTableData, specificationList, setSpecificationList, setRemark, setChildPartFiles, remark, partListData, sopQuantityList, setSopQuantityList, sopdate, n100Date, sopDate, setSopDate, setN100Date, setSOPDate, effectiveMinDate, childPartFiles, rmSpecificRowData, partType, bopNumber, handleDrawer, drawerViewMode, resetDrawer, partTypeInPartList, hitRatePerDay, plant, selectedPlantForVolume: propSelectedPlantForVolume, setSelectedPlantForVolume: propSetSelectedPlantForVolume, isMultipleRMApplied } = props
    const type = String(props?.type)
    const { register, handleSubmit, setValue, getValues, formState: { errors }, control } = useForm({
        mode: 'onChange',
        reValidateMode: 'onChange',
    });
    const rawMaterialNameSelectList = useSelector(state => state?.material?.rawMaterialNameSelectList);
    const gradeSelectList = useSelector(state => state?.material?.gradeSelectList);
    const rmSpecification = useSelector(state => state?.comman?.rmSpecification);
    const { getChildParts, getRfqPartDetails, bopSpecificRowData, toolingSpecificRowData } = useSelector(state => state?.rfq);


    const rmSpecificationList = useSelector((state) => state.material.rmSpecificationList)
    // const [sopQuantityList, setSopQuantityList] = useState([]);


    const [rmspecification, setRMSpecification] = useState([])
    const [rmName, setRMName] = useState([])
    const [rmgrade, setRMGrade] = useState([])

    const [rmNameSelected, setRmNameSelected] = useState(false)
    const [selectedparts, setSelectedParts] = useState([])
    const [partName, setPartName] = useState('')
    const [storeNfrId, setStoreNfrId] = useState('')
    const [inputLoader, setInputLoader] = useState(false)
    const [isEdit, setIsEdit] = useState(false)
    const [activeTab, setActiveTab] = useState(props.partType === 'Raw Material' ? "5" : props.partType === 'Bought Out Part' ? '2' : '1');

    const [specification, setSpecification] = useState("")
    const [editIndex, setEditIndex] = useState(null);  // To keep track of the index being edited
    const [files, setFiles] = useState([]);  // State for files
    const [attachmentLoader, setAttachmentLoader] = useState(false);
    const plantLoaderObj = { isLoader: inputLoader }
    const [apiCallCounter, setApiCallCounter] = useState(0)
    const [IsOpen, setIsOpen] = useState(false);
    const [isDisable, setIsDisable] = useState(false)
    const [valueState, setValueState] = useState('')
    const [selectedValues, setSelectedValues] = useState([]);
    const [childPart, setChildPart] = useState([])
    const [gridColumnApi, setGridColumnApi] = useState(null);
    const [gridApi, setGridApi] = useState(null);
    const [sopQuantity, setSopQuantity] = useState([])
    const [state, setState] = useState(false)

    const [fiveyearList, setFiveyearList] = useState([])
    const [isNewDate, setIsNewDate] = useState(false)
    const [showTooltip, setShowTooltip] = useState(false)
    const [viewTooltip, setViewTooltip] = useState(false)
    const [partRemark, setPartRemark] = useState('')
    const [rmCode, setRMCode] = useState([])
    const [disabled, setDisabled] = useState(false)
    // Use parent's selected plant state if provided, otherwise use local state
    const selectedPlantForVolume = propSelectedPlantForVolume !== undefined ? propSelectedPlantForVolume : []
    const setSelectedPlantForVolume = propSetSelectedPlantForVolume || (() => {})

    // State for temporary plant and hit rate selection before adding to table
    const [selectedPlant, setSelectedPlant] = useState(null)
    const [HitRate, setHitRate] = useState('')

    // State for editing plant rows - tracks which plant is being edited
    const [editingPlantRow, setEditingPlantRow] = useState(null)

    // State for deleting plants
    const [isDeleting, setIsDeleting] = useState(false)

    // Add this useEffect to handle plant code value setting
    useEffect(() => {
        if (editingPlantRow && selectedPlant) {
            // Small delay to ensure the component is ready
            const timer = setTimeout(() => {
                setValue('PlantCode', selectedPlant);
            }, 100);
            
            return () => clearTimeout(timer);
        }
    }, [editingPlantRow, selectedPlant, setValue]);
    
    // Set default SOP date to current date when ANNUAL_FORECAST_MANDATORY is false
    useEffect(() => {
        // Only proceed for Component, Assembly, and Tooling (where volume section is shown)
        if (partType === "Component" || partType === "Assembly" || partType === "Tooling") {
            // When ANNUAL_FORECAST is not mandatory, set default date to current date
            if (!RFQ_KEYS?.ANNUAL_FORECAST_MANDATORY && isOpen) {
                const isVolumeTabActive = (partType === "Component" || partType === "Assembly") ? activeTab === "2" : activeTab === "3";

                // In ADD mode: Always set default date if sopdate is empty and we're on the volume tab
                if (!isEditFlag && !isViewFlag && !sopdate && isVolumeTabActive) {
                    const currentDate = new Date();
                    const formattedDate = DayTime(currentDate).format('YYYY-MM-DD HH:mm:ss');
                    setSOPDate(formattedDate);
                    setSopDate(currentDate);
                }
                // In EDIT mode: Set default date only if there's no existing sopdate from the saved data
                else if (isEditFlag && !isViewFlag && isVolumeTabActive) {
                    // Check if sopdate is truly empty (not just falsy, but actually empty/null/undefined)
                    // Wait a moment for data restoration to complete before setting default
                    const timer = setTimeout(() => {
                        // Only set default if sopdate is still empty after data restoration
                        if (!sopdate || sopdate === '') {
                            const currentDate = new Date();
                            const formattedDate = DayTime(currentDate).format('YYYY-MM-DD HH:mm:ss');
                            setSOPDate(formattedDate);
                            setSopDate(currentDate);
                        }
                    }, 100); // Small delay to allow data restoration to complete first

                    return () => clearTimeout(timer);
                }
            }
        }
    }, [isOpen, partType, isEditFlag, isViewFlag, activeTab]);

    useEffect(() => {

        if (partType === 'Component') {
            setValue('AssemblyPartNumber', { label: AssemblyPartNumber?.label, value: AssemblyPartNumber?.value })
            if (type === Component || type === BoughtOutPart) {
                setValue('partNumber', { label: AssemblyPartNumber?.label, value: AssemblyPartNumber?.value })
                // Also set childPart state for consistent filtering in renderListingRM
                setChildPart({ label: AssemblyPartNumber?.label, value: AssemblyPartNumber?.value })
            } else {
                // For Assembly, fetch child parts (will auto-select if no child parts exist via separate useEffect)
                if (!isViewFlag) {
                    dispatch(getAssemblyChildpart(AssemblyPartNumber?.value, (res) => { }))
                }
            }
        } else if (partType === "Bought Out Part") {
            setValue('AssemblyPartNumber', { label: bopNumber?.label, value: bopNumber?.value })
        }

        // Set hitRatePerDay value if provided
        if (hitRatePerDay) {
            setValue('HitRatePerDay', hitRatePerDay);
        }

        // Initialize selected plants for volume dropdown
        if (plant && !isViewFlag && !isEditFlag) {
            if (isPlantMultiSelectEnabled()) {
                // Multi-select mode: clear the field for manual selection
                const plantArray = Array.isArray(plant) ? plant : (plant?.label ? [plant] : []);
                // Only clear plants on initial creation, not when editing
                if (selectedPlantForVolume.length === 0) {
                    setSelectedPlantForVolume([]);
                    setValue('PlantCode', []);
                }
            } else {
                // Single-select mode: normalize plant format (handle both object and array)
                const normalizedPlant = Array.isArray(plant) && plant.length > 0 ? plant[0] : plant;
                if (normalizedPlant && normalizedPlant.value) {
                    setValue('PlantCode', normalizedPlant);
                }
            }
        }

    }, [AssemblyPartNumber, bopNumber, partType, type, hitRatePerDay, plant, isEditFlag])

    // Auto-select Part No for Assembly when no child parts exist (Plastic technology scenario)
    useEffect(() => {
        if (isOpen && partType === 'Component' && partTypeInPartList === "Assembly" && !isViewFlag) {
            // Check if child parts have been fetched and are empty
            if (getChildParts !== undefined && (!getChildParts || getChildParts.length === 0)) {
                // Auto-select the Assembly part number when no child parts exist
                setValue('partNumber', { label: AssemblyPartNumber?.label, value: AssemblyPartNumber?.value })
                // Also set childPart state for consistent filtering in renderListingRM
                setChildPart({ label: AssemblyPartNumber?.label, value: AssemblyPartNumber?.value })
            }
        }
    }, [isOpen, partType, partTypeInPartList, getChildParts, AssemblyPartNumber, isViewFlag, setValue])

    useEffect(() => {
        if (partType === "Component")
            if (!isViewFlag) {
                dispatch(getRawMaterialNameChild(() => { }))
                dispatch(getRMSpecificationDataList({ GradeId: null }, () => { }))
            }
    }, [partType])
    useEffect(() => {
        if (partType === "Component" || partType === "Assembly") {

            // Only restore if truly in edit/view mode AND has valid data with actual content
            if ((isEditFlag || isViewFlag) && getRfqPartDetails && getRfqPartDetails?.PartList && getRfqPartDetails?.PartList.length > 0) {

                const partList = getRfqPartDetails?.PartList || [];
                let accumulatedRMDetails = [];
                const sopDate = partList[0]?.SOPDate

                setSOPDate(sopDate || '')
                if (partList.length > 0) {
                    let arr = []
                    partList.forEach((part, index) => {
                        const PartId = part.PartId || '';
                        const PartNumber = part.PartNumber || '';
                        if (index === 0) {
                            const allSopQuantityDetails = part?.SOPQuantityDetails || []
                            setSopQuantityList(sopQuantityList => allSopQuantityDetails)

                            // Restore selected plants from SOPQuantityDetails
                            if (allSopQuantityDetails && allSopQuantityDetails.length > 0) {
                                const uniquePlants = [...new Set(allSopQuantityDetails.map(item => item.PlantId))];
                                const plantOptions = Array.isArray(plant) ? plant : (plant?.label ? [plant] : []);
                                const selectedPlants = plantOptions.filter(p => uniquePlants.includes(p.value));
                                if (selectedPlants.length > 0) {
                                    setSelectedPlantForVolume(selectedPlants);
                                    // Don't set PlantCode field - it's for manual selection only
                                    // The selected plants are shown in the table below
                                }
                            }
                        }
                        if (index === 0) {
                            const allSpecifications = (part.PartSpecification || []).map(detail => ({
                                ...detail,
                                PartId: PartId,
                                PartNumber: PartNumber,
                                uniqueKey: `${PartId}-${detail.Specification}` //QuotationPartSpecificationIdRef
                            }));

                            arr.push(...allSpecifications)


                            const remarks = part.Remarks || '';

                            setValue('remark', remarks);
                            setRemark(remarks);
                            const allFiles = part.Attachments || [];
                            setValue("HitRatePerDay", part?.HitRatePerDay);
                            setFiles(files => [...allFiles]);
                            setChildPartFiles(childPartFiles => [...allFiles]);
                        }
                        if (part.RMDetails && part.RMDetails.length > 0) {
                            const allRMDetails = part.RMDetails.map(detail => ({
                                ...detail,
                                PartId: PartId,
                                PartNumber: PartNumber,
                                uniqueKey: `${PartId}-${detail.RawMaterialCodeId || detail.RawMaterialSpecificationId}`
                            }));

                            accumulatedRMDetails = [...accumulatedRMDetails, ...allRMDetails];

                        }


                        // For multiple RMs per part, use uniqueKey (PartId + RawMaterialCodeId) instead of just PartId
                        setTableData(tableData => _.uniqBy(accumulatedRMDetails, 'uniqueKey'));

                    });
                    setSpecificationList(specificationList => _.uniqBy([...arr], 'QuotationPartSpecificationIdRef'));
                }
            }
        }
    }, [getRfqPartDetails, isViewFlag, isEditFlag]);

    // useEffect to update disabled state when tableData or selected part changes
    useEffect(() => {
        // Don't disable during edit mode - user needs to edit the fields
        if (isEdit) {
            setDisabled(false);
            return;
        }

        // isMultipleRMApplied = true: Never disable fields, allow unlimited RMs
        // isMultipleRMApplied = false: Disable based on rules (1 RM per Part)
        const allowMultipleRM = isMultipleRMApplied === true;

        if (allowMultipleRM) {
            // Multiple RMs allowed - never disable
            setDisabled(false);
        } else {
            // KEY = FALSE: Single RM per part - apply disable rules
            // Check if CURRENTLY SELECTED Part Number already has an RM
            const currentPartId = childPart?.value;

            if (currentPartId) {
                // If a Part is selected, check if it already has RM in tableData
                const currentPartHasRM = tableData.some(item => String(item.PartId) === String(currentPartId));
                setDisabled(currentPartHasRM);
            } else {
                // No Part selected yet - use existing logic for initial state
                if (partTypeInPartList === "Assembly") {
                    const originalChildPartsCount = getChildParts?.length || 0;
                    if (originalChildPartsCount > 0) {
                        // Check if all child parts have at least one RM
                        const childPartIds = getChildParts.map(part => part.Value);
                        const addedPartIds = tableData.map(data => data.PartId);
                        const allPartsHaveRM = childPartIds.every(partId => addedPartIds.includes(partId));
                        setDisabled(allPartsHaveRM);
                    } else {
                        setDisabled(tableData.length > 0);
                    }
                } else {
                    // Component case - disable if tableData has any data
                    setDisabled(tableData.length > 0);
                }
            }
        }
    }, [tableData, partTypeInPartList, getChildParts, isEdit, childPart, isMultipleRMApplied]);

    // Additional useEffect to restore data from props when drawer reopens
    useEffect(() => {
        if (isOpen && (partType === "Component" || partType === "Assembly")) {
            // If we have sopQuantityList from props and it's not empty, restore it
            if (sopQuantityList && sopQuantityList.length > 0 && !isViewFlag) {
                setSopQuantityList(sopQuantityList);

                // Also restore selected plants if available - DO NOT set form field value
                // The PlantCode field should remain empty for manual plant selection
                if (selectedPlantForVolume && selectedPlantForVolume.length > 0) {
                    setSelectedPlantForVolume(selectedPlantForVolume);
                    // Don't set PlantCode field - it should be empty for adding new plants
                }
                
                // Restore SOP date if available
                if (sopdate) {
                    setSOPDate(sopdate);
                }
                
                // Restore Hit Rate Per Day if available
                if (hitRatePerDay) {
                    setValue('HitRatePerDay', hitRatePerDay);
                }
            }
        }
    }, [isOpen, partType, isViewFlag]);

    // Initialize PlantCode field value in single-plant mode
    useEffect(() => {
        if (isOpen && !isPlantMultiSelectEnabled() && plant) {
            // Normalize plant format (handle both object and array)
            const normalizedPlant = Array.isArray(plant) && plant.length > 0 ? plant[0] : plant;
            if (normalizedPlant && normalizedPlant.value) {
                setValue('PlantCode', normalizedPlant);
            }
        }
    }, [isOpen, plant]);

    useEffect(() => {
        if (partType === 'Raw Material') {
            if ((isEditFlag || isViewFlag) && rmSpecificRowData.length > 0) {
                setValue('remark', rmSpecificRowData[0].Remarks);
                setRemark(rmSpecificRowData[0].Remarks)
                setFiles(rmSpecificRowData[0].Attachments);
                setChildPartFiles(rmSpecificRowData[0].Attachments);
            }
        }
    }, [partType, rmSpecificRowData, isEditFlag, isViewFlag])

    // Disabled automatic plant generation - now using manual Add button
    // This useEffect is kept for edit mode data restoration only
    useEffect(() => {
        // Skip if we're in the middle of a delete operation
        if (isDeletingPlant.current) {
            return;
        }

        // Only run this for edit/view mode to restore data, not for manual addition
        if (!isEditFlag && !isViewFlag) {
            return; // Skip for add mode - user will use Add button
        }

        if (sopdate && !(isViewFlag) && selectedPlantForVolume) {
            const plantsArray = Array.isArray(selectedPlantForVolume) ? selectedPlantForVolume : (selectedPlantForVolume?.label ? [selectedPlantForVolume] : []);

            // If no plants selected, clear the list only in add mode
            if (plantsArray.length === 0) {
                if (!isEditFlag) {
                    setSopQuantityList([]);
                }
                return;
            }

            // Calculate years directly from sopdate
            const year = new Date(sopdate).getFullYear();
            const yearList = [];
            for (let i = 0; i < 5; i++) {
                yearList.push(year + i);
            }

            // Skip regeneration if in edit mode and data was already loaded from Redux or props
            if (isEditFlag && sopQuantityList?.length > 0) {
                // Check if data has meaningful content (not just empty structure)
                const hasLoadedData = sopQuantityList.some(item => 
                    item.PlantId || item.PartNumber || item.PlantCode || 
                    (item.Quantity !== undefined && item.Quantity !== null)
                );
                if (hasLoadedData) {
                    return;
                }
            }

            // Check if this is initial data generation
            const isInitialGeneration = sopQuantityList?.length === 0 || isNewDate || (isEditFlag && sopQuantityList?.length === 0);
            
            // Don't regenerate if we're reopening the drawer with existing data
            if (isEditFlag && sopQuantityList?.length > 0 && !isNewDate) {
                return;
            }

            if (isInitialGeneration) {
                // Initial data generation - create data for all selected plants
                const currentHitRate = getValues('HitRatePerDay') || hitRatePerDay || '';
                let arrTemp = [];
                plantsArray.forEach((plantItem, plantIdx) => {
                    sopObjectTemp.forEach((item, index) => {
                        let newObjTemp = {};
                        // Every row should have PartNumber, PlantCode, and HitRatePerDay for Redux storage
                        newObjTemp.PartNumber = AssemblyPartNumber?.label || '';
                        newObjTemp.PlantCode = plantItem?.label || '';
                        newObjTemp.PlantId = plantItem?.value || '';
                        newObjTemp.PlantValue = plantItem?.value || '';
                        newObjTemp.HitRatePerDay = currentHitRate;
                        newObjTemp.SOPDate = sopdate;
                        newObjTemp.PlantIndex = Number(plantIdx);
                        newObjTemp.RowIndexInGroup = index; // Track row position within plant group (0-4)
                        newObjTemp.Quantity = 0;
                        newObjTemp.YearName = yearList[index];
                        newObjTemp.isEdit = true;
                        // Mark last row of each plant group for separator line
                        if (index === sopObjectTemp.length - 1) {
                            newObjTemp.LastRow = true;
                        }
                        arrTemp.push(newObjTemp);
                    });
                });
                setSopQuantityList(arrTemp);
            } else {
                // Plant selection changed - need to update data
                const selectedPlantValues = plantsArray.map(p => p?.value);
                const existingPlantValues = [...new Set(sopQuantityList.map(r => r.PlantId))];

                // Check if plants actually changed
                const plantsChanged =
                    selectedPlantValues.length !== existingPlantValues.length ||
                    !selectedPlantValues.every(v => existingPlantValues.includes(v));

                if (plantsChanged) {
                    // Keep existing data for plants that are still selected, preserving quantities
                    let existingData = sopQuantityList.filter(row =>
                        selectedPlantValues.includes(row.PlantId)
                    );

                    // Update PlantIndex and PlantCode for existing rows based on new plant order
                    const updatedExistingData = existingData.map(row => {
                        const plantValue = row.PlantId;
                        const newIndex = plantsArray.findIndex(p => p?.value === plantValue);
                        const plantItem = plantsArray[newIndex];

                        // Update PlantCode in middle row (where PartNumber exists) - DO NOT touch HitRatePerDay
                        if (row.PartNumber && row.PartNumber !== '') {
                            return { 
                                ...row, 
                                PlantIndex: Number(newIndex), 
                                PlantCode: plantItem?.label || '', 
                                // HitRatePerDay is intentionally NOT updated - preserve existing value
                                LastRow: false 
                            };
                        }
                        return { ...row, PlantIndex: Number(newIndex), LastRow: false };
                    });

                    // Find newly added plants
                    const newPlants = plantsArray.filter(p => !existingPlantValues.includes(p?.value));

                    // Generate data for newly added plants
                    const currentHitRate = getValues('HitRatePerDay') || hitRatePerDay || '';
                    let newPlantData = [];
                    newPlants.forEach(plantItem => {
                        const plantIdx = plantsArray.findIndex(p => p?.value === plantItem?.value);
                        sopObjectTemp.forEach((item, index) => {
                            let newObjTemp = {};
                            // Every row should have PartNumber, PlantCode, and HitRatePerDay for Redux storage
                            newObjTemp.PartNumber = AssemblyPartNumber?.label || '';
                            newObjTemp.PlantCode = plantItem?.label || '';
                            newObjTemp.PlantId = plantItem?.value || '';
                            newObjTemp.PlantValue = plantItem?.value || '';
                            newObjTemp.HitRatePerDay = currentHitRate;
                            newObjTemp.SOPDate = sopdate;
                            newObjTemp.PlantIndex = Number(plantIdx);
                            newObjTemp.RowIndexInGroup = index; // Track row position within plant group (0-4)
                            newObjTemp.Quantity = 0;
                            newObjTemp.YearName = yearList[index];
                            newObjTemp.isEdit = true;
                            // Mark last row of each plant group for separator line
                            if (index === sopObjectTemp.length - 1) {
                                newObjTemp.LastRow = true;
                            }
                            newPlantData.push(newObjTemp);
                        });
                    });

                    // Combine and sort by PlantIndex
                    const combinedData = [...updatedExistingData, ...newPlantData].sort((a, b) => a.PlantIndex - b.PlantIndex);
                    
                    // Set LastRow property correctly for each plant group
                    const finalData = combinedData.map((row, index) => {
                        const isLastRowOfPlant = index === combinedData.length - 1 || 
                            (index < combinedData.length - 1 && combinedData[index + 1].PlantId !== row.PlantId);
                        return { ...row, LastRow: isLastRowOfPlant };
                    });
                    
                    setSopQuantityList(finalData);
                }
            }
        }
    }, [sopdate, selectedPlantForVolume, AssemblyPartNumber])
    useEffect(() => {
        if (!isViewFlag && !isEditFlag) {
            if ((childPartFiles?.length > 0 || remark !== "")) {
                setValue("remark", remark)
                setFiles(childPartFiles)
            }

        }
    }, [isEditFlag, isViewFlag])
    useEffect(() => {


        if (partType === "Bought Out Part") {
            if ((isEditFlag || isViewFlag) && bopSpecificRowData && bopSpecificRowData.length > 0) {
                setValue('AssemblyPartNumber', { label: bopSpecificRowData[0]?.BoughtOutPartNumber, value: bopSpecificRowData[0]?.BoughtOutPartChildId })
                const BoughtOutPartChildId = bopSpecificRowData[0]?.BoughtOutPartChildId
                const allSpecifications = (bopSpecificRowData[0]?.PartSpecification || []).map(detail => ({
                    ...detail,
                    BoughtOutPartChildId: BoughtOutPartChildId,
                    uniqueKey: `${BoughtOutPartChildId}-${detail.Specification}` //QuotationPartSpecificationIdRef
                }));
                setSpecificationList(specificationList => _.uniqBy([...allSpecifications], 'uniqueKey'));
                setValue('remark', bopSpecificRowData[0].Remarks);
                setRemark(bopSpecificRowData[0].Remarks)
                setFiles(bopSpecificRowData[0].Attachments);
                setChildPartFiles(bopSpecificRowData[0].Attachments);
            }
        }
    }, [bopSpecificRowData, isViewFlag, isEditFlag, partType]);
    useEffect(() => {
        if (resetDrawer && partType === "Component") {
            setTableData([])
            setSpecificationList([])
            setSopQuantityList([])
            setSOPDate('')
            setRemark('')
            setFiles([])
            setChildPartFiles([])
            setIsEdit(false)
            setEditIndex(null)
            handleDrawer(false)
        }
    }, [resetDrawer])
    useEffect(() => {
        if (partType === "Tooling") {
            if ((isEditFlag || isViewFlag) && toolingSpecificRowData && toolingSpecificRowData.length > 0) {

                let accumulatedRMDetails = [];
                // const sopDate = toolingSpecificRowData[0]?.SOPDate

                // setSOPDate(sopDate || '')
                if (toolingSpecificRowData.length > 0) {

                    let arr = []
                    toolingSpecificRowData.forEach((part, index) => {


                        const PartId = part.ToolId || '';

                        if (index === 0) {
                            const sopDate = part?.SOPDate
                            const allSopQuantityDetails = part?.SOPQuantity || []
                            setSOPDate(sopDate || '')

                            setSopQuantityList(sopQuantityList => allSopQuantityDetails)

                            const allSpecifications = (part.ToolSpecificationList || []).map(detail => ({
                                ...detail,
                                PartId: PartId,
                                uniqueKey: `${PartId}-${detail.Specification}` //QuotationPartSpecificationIdRef
                            }));

                            arr.push(...allSpecifications)


                            const remarks = part.Remarks || '';
                            setValue('remark', remarks);
                            setRemark(remarks);
                            const allFiles = part.Attachments || [];

                            setFiles(files => [...allFiles]);
                            setChildPartFiles(childPartFiles => [...allFiles]);
                        }
                        if (part.ToolChildList && part.ToolChildList.length > 0) {
                            const allRMDetails = part.ToolChildList.map(detail => ({
                                ...detail,
                            }));


                            accumulatedRMDetails = [...accumulatedRMDetails, ...allRMDetails];

                        }


                        // setTableData(tableData => _.uniqBy([...allRMDetails], 'RawMaterialChildId'));
                        setTableData(tableData => _.uniqBy(accumulatedRMDetails, 'PartId'));

                    });
                    setSpecificationList(specificationList => _.uniqBy([...arr], 'QuotationPartSpecificationIdRef'));
                }
            }
        }
    }, [isViewFlag, isEditFlag, partType, toolingSpecificRowData])

    const removeAddedParts = (arr) => {
        const filteredArray = arr.filter((item) => {
            return !selectedparts.some((element) => {
                return element.value === item.value;
            });
        });
        return filteredArray
    }
    const validateForm = () => {
        return (
            specification !== '' &&
            valueState !== '' &&
            remark !== '' &&
            files.length > 0
        );
    };

    const toggleDrawer = (event) => {

        if (
            event.type === 'keydown' &&
            (event.key === 'Tab' || event.key === 'Shift')
        ) {
            return
        }
        props.closeDrawer('', false)
        if (props?.setViewQuotationPart && typeof props.setViewQuotationPart === 'function') {
            props.setViewQuotationPart(false);
        }
        if (drawerViewMode) {
            setTableData([])
            setSpecificationList([])
            setSopQuantityList([])
            setSOPDate('')
            setRemark('')
            setFiles([])
            setChildPartFiles([])
            setIsEdit(false)
            setEditIndex(null)
            handleDrawer(false)
        }

    }
    const renderListingRM = (label) => {

        let opts1 = []
        if (label === 'childPartName') {
            const opts1 = [];

            getChildParts && getChildParts?.map(item => {
                // if (item.Value === '0') return false;
                opts1.push({ label: item.Text, value: item.Value })
            });

            if (isMultipleRMApplied) {
                // isMultipleRMApplied=TRUE: Show all Part Numbers (can add multiple RMs per part)
                return opts1;
            } else {
                // isMultipleRMApplied=FALSE: Filter out Part Numbers that already have RM added
                // But keep the one being edited so user can see it
                let addedPartIds = tableData.map(data => String(data.PartId));

                // If in edit mode, don't filter out the part being edited
                if (isEdit && editIndex !== null && tableData[editIndex]) {
                    const editingPartId = String(tableData[editIndex].PartId);
                    addedPartIds = addedPartIds.filter(id => id !== editingPartId);
                }

                // Filter out parts that already have RM
                return opts1.filter(opt => !addedPartIds.includes(String(opt.value)));
            }
        }
        if (label === 'rmname') {
            if (rawMaterialNameSelectList?.length > 0) {
                let opts = [...rawMaterialNameSelectList]
                opts && opts?.map(item => {
                    if (item.Value === '0') return false
                    item.label = item.Text
                    item.value = item.Value
                    opts1.push(item)
                    return null
                })
            }
            return opts1
        }
        if (label === 'rmgrade') {
            if (gradeSelectList?.length > 0) {
                let opts = [...gradeSelectList]
                opts && opts?.map(item => {
                    if (item.Value === '0') return false
                    item.label = item.Text
                    item.value = item.Value
                    opts1.push(item)
                    return null
                })
            }
            return opts1
        }

        if (label === 'rmspecification') {
            if (rmSpecification?.length > 0) {
                let opts = [...rmSpecification]
                opts && opts?.map(item => {
                    if (item.Value === '0') return false
                    item.label = item.Text
                    item.value = item.Value
                    opts1.push(item)
                    return null
                })
            }
            return opts1
        }
        if (label === 'rmcode') {
            if (rmSpecificationList?.length > 0) {
                let opts = [...rmSpecificationList]

                if (isMultipleRMApplied) {
                    // Get currently selected Part No - use form value or childPart state as fallback
                    const currentPartId = getValues('partNumber')?.value || childPart?.value;

                    // Get list of already added RM Codes for the CURRENT Part No only
                    // Exclude the currently editing item so it remains visible in dropdown
                    const addedRMCodesForCurrentPart = tableData?.filter((item, index) => {
                        // During edit mode, exclude the item being edited
                        if (isEdit && editIndex !== null && index === editIndex) {
                            return false;
                        }
                        // Only include RMs for the current Part No (compare as strings)
                        return String(item.PartId) === String(currentPartId);
                    }) || [];

                    // Get both Code IDs and Code labels for comparison (API data may have different format)
                    const addedRMCodeIds = addedRMCodesForCurrentPart.map(item => String(item.RawMaterialCodeId));
                    const addedRMCodeLabels = addedRMCodesForCurrentPart.map(item => String(item.RawMaterialCode));

                    opts && opts?.map(item => {
                        if (item.Value === '0') return false
                        // Filter out RM codes already added for THIS Part No
                        // Check both by ID (SpecificationId) and by label (RawMaterialCode) to handle API data
                        const isAlreadyAdded = addedRMCodeIds.includes(String(item.SpecificationId)) ||
                                               addedRMCodeLabels.includes(String(item.RawMaterialCode));
                        if ((partTypeInPartList === "Component" || partTypeInPartList === "Assembly") && isAlreadyAdded) {
                            return null
                        }
                        item.label = item.RawMaterialCode
                        item.value = item.SpecificationId
                        opts1.push(item)
                        return null
                    })
                } else {
                    // Original logic - no filtering, all codes available
                    opts && opts?.map(item => {
                        if (item.Value === '0') return false
                        item.label = item.RawMaterialCode
                        item.value = item.SpecificationId
                        opts1.push(item)
                        return null
                    })
                }
            }
            return opts1
        }
    }
    const handleChildPart = (newValue) => {

        setSelectedValues(prevSelected => [...prevSelected, newValue?.value]);
        setChildPart({ label: newValue?.label, value: newValue?.value })
        // Also set form value to ensure getValues('partNumber') returns correct value immediately
        setValue('partNumber', { label: newValue?.label, value: newValue?.value });

        if (isMultipleRMApplied) {
            // Allow multiple RMs - never disable
            setDisabled(false);
        } else {
            // Original logic - disable if part already has RM
            const partHasRM = tableData.some(item => item.PartId === newValue?.value);
            setDisabled(partHasRM);
        }
    }

    const handleRMName = (newValue) => {
        setRMName({ label: newValue?.label, value: newValue?.value })
        setRmNameSelected(true)
        setValue('RMGrade', '')
        setValue('RMSpecification', '')
        dispatch(getRMGradeSelectListByRawMaterial(newValue.value, false, (res) => { }))
    }

    const handleRMGrade = (newValue) => {
        setRMGrade({ label: newValue?.label, value: newValue?.value })
        setValue('RMSpecification', '')
        dispatch(fetchSpecificationDataAPI(newValue.value, (res) => { }))
    }

    const handleRMSpecification = (newValue) => {
        setRMSpecification({ label: newValue?.label, value: newValue?.value })
        setRMCode({ label: newValue.RawMaterialCode, value: newValue.SpecificationId })
        setValue('rmcode', { label: newValue.RawMaterialCode, value: newValue.value })
    }
    const handleRemarkChange = (newValue) => {

        setValue('remark', newValue)
        setRemark(newValue);
    }
    const resetFormAndDropdowns = (skipDisableUpdate = false) => {
        if (type !== Component) {
            setValue('partNumber', '')
            setChildPart([])  // Reset childPart state for non-Component types
        }
        setValue('RMName', '')
        setValue('RMGrade', '')
        setValue('RMSpecification', '')
        setValue('Specification', '')
        setValue('Value', '')
        setValue("rmcode", "")
        // Reset local dropdown states
        setRMName([])
        setRMGrade([])
        setRMCode([])

        // Skip disable update when called from addRow/deleteRow (useEffect handles it with correct data)
        if (!skipDisableUpdate) {
            const allowMultipleRM = isMultipleRMApplied === true;

            if (allowMultipleRM) {
                // Allow multiple RMs - never disable
                setDisabled(false)
            } else {
                // Single RM per part - disable based on tableData and child parts
                if (partTypeInPartList === "Assembly") {
                    const originalChildPartsCount = getChildParts?.length || 0
                    if (originalChildPartsCount > 0) {
                        // Check if all child parts have at least one RM
                        const childPartIds = getChildParts?.map(part => part.Value) || [];
                        const addedPartIds = tableData?.map(data => data.PartId) || [];
                        const allPartsHaveRM = childPartIds.every(partId => addedPartIds.includes(partId));
                        setDisabled(allPartsHaveRM)
                    } else {
                        setDisabled(tableData.length > 0)
                    }
                } else {
                    setDisabled(tableData.length > 0)
                }
            }
        }
    };

    const handleSpecification = (newValue) => {
        setSpecification(newValue)
    }

    const handleValue = (value) => {
        setValueState(value)
    }
    /**
         * @method addRow
         * @description For updating and adding row
         */
    const addRow = (activeTab) => {
        if (errors.Specification || errors.Value) {
            Toaster.warning("Please fix the validation errors");
            return;
        }
        const formData = getValues();
        const partNumberLabel = formData.partNumber?.label || '-';
        const partIdRef = formData.partNumber?.value || '-';
        const rmNameLabel = formData.RMName?.label || '-';
        const rmChildId = formData.RMName?.value || '-';
        const rmGradeId = formData.RMGrade?.value || '-';
        const rmSpecificationId = formData.RMSpecification?.value || '-';
        const rmGradeLabel = formData.RMGrade?.label || '-';
        const rmSpecificationLabel = formData.RMSpecification?.label || '-';
        const rmCodeLabel = formData.rmcode?.label || '-';
        const rmCodeValue = formData.rmcode?.value || '-';
        const specificationValue = formData.Specification || '-';
        const value = formData.Value || '-';

        const obj = {
            PartNumber: partNumberLabel,
            PartId: partIdRef,
            RawMaterialName: rmNameLabel,
            RawMaterialChildId: rmChildId,
            RawMaterialGrade: rmGradeLabel,
            RawMaterialGradeId: rmGradeId,
            RawMaterialSpecificationId: rmSpecificationId,
            RawMaterialSpecification: rmSpecificationLabel,
            RawMaterialCode: rmCodeLabel,
            RawMaterialCodeId: rmCodeValue,
            childPart: true,
        };
        const specificationObj = {
            Specification: specificationValue,
            SpecificationId: rmSpecificationId,
            Value: value,
        }

        if (isEdit) {
            if (activeTab === "2") {
                if (editIndex !== null && editIndex >= 0 && editIndex < specificationList.length) {
                    const newspecificationData = [...specificationList];
                    newspecificationData[editIndex] = specificationObj;
                    setSpecificationList(newspecificationData);
                }
            } else {
                if (!formData.RMName || !formData.RMGrade || !formData.RMSpecification) {
                    const missingFields = [];
                    if (!formData.RMName) missingFields.push('RM Name');
                    if (!formData.RMGrade) missingFields.push('RM Grade');
                    if (!formData.RMSpecification) missingFields.push('RM Specification');
                    Toaster.warning(`Please select ${missingFields.join(', ')}`);
                    return;
                }
                // Safety check: ensure editIndex is valid before replacing
                if (editIndex !== null && editIndex >= 0 && editIndex < tableData.length) {
                    const newData = [...tableData];
                    newData[editIndex] = obj;
                    setTableData(newData);
                }
            }
            setIsEdit(false);
            setEditIndex(null);
            resetFormAndDropdowns(true);
        } else if (activeTab === "2") {
            const specification = getValues('Specification');
            const IsValueMissing = !getValues('Value');
            if (specification !== undefined && IsValueMissing) {
                Toaster.warning("Please enter value");
            }

            // else if (specificationList.length >= 3) {
            //     Toaster.warning("You can only add up to 3 specifications.");
            // } 
            else {
                setSpecificationList(prevData => [...prevData, specificationObj]);
                resetFormAndDropdowns();
            }

        } else {
            // Validate all mandatory fields before adding
            const missingFields = [];

            // Check Part No for Assembly with child parts
            const hasChildParts = partTypeInPartList === 'Assembly' && getChildParts?.length > 0;
            const isPartNoMissing = hasChildParts && !getValues('partNumber')?.value;
            if (isPartNoMissing) {
                missingFields.push('Part No');
            }

            // Check RM fields
            const isRMNameMissing = !getValues('RMName')?.value;
            const isRMGradeMissing = !getValues('RMGrade')?.value;
            const isRMSpecificationMissing = !getValues('RMSpecification')?.value;
            const isCodeMissing = !getValues('rmcode')?.value;

            if (isRMNameMissing) missingFields.push('RM Name');
            if (isRMGradeMissing) missingFields.push('RM Grade');
            if (isRMSpecificationMissing) missingFields.push('RM Specification');
            if (isCodeMissing) missingFields.push('Code');

            if (missingFields.length > 0) {
                Toaster.warning(`Please select ${missingFields.join(', ')}`);
                return;
            }

            setTableData(prevData => [...prevData, obj]);
            resetFormAndDropdowns(true);
        }
    };


    const rateTableReset = () => {

        resetFormAndDropdowns();
    }
    const handleCloseDrawer = () => {
        //tableData
        // if (isViewFlag || isEditFlag) {
        //     saveRfqPartsData()

        // }

        // Get hitRatePerDay value - get from sopQuantityList instead of form
        const hitRatePerDay = sopQuantityList && sopQuantityList.length > 0
            ? sopQuantityList.find(item => item.HitRatePerDay !== '' && item.HitRatePerDay !== null)?.HitRatePerDay || ''
            : '';

        if (partType === "Component" || partType === "Tooling" || partType === "Bought Out Part") {
            const hasNonZeroQuantity = sopQuantityList && sopQuantityList.length > 0 && sopQuantityList[0].Quantity !== 0 && sopQuantityList[0].Quantity !== '0';
            if (partType === "Component" || partType === "Tooling") {
                const dropdownTexts = _.map(getChildParts, 'Text');
                const tableTexts = _.map(tableData, 'PartNumber');
                const allPresent = _.every(dropdownTexts, text => _.includes(tableTexts, text));
                if (RFQ_KEYS?.RM_MANDATORY && (type !== Component && partType !== "Tooling")) {

                    if (!allPresent) {
                        Toaster.warning('RM Name, RM Grade, and RM Specification are required for each part.');
                        return;
                    }
                } else if (RFQ_KEYS?.RM_MANDATORY && ((type === Component || type === BoughtOutPart) && tableData.length === 0)) {
                    Toaster.warning('RM Name, RM Grade, and RM Specification are required.');
                    return;
                }
            }

            if (RFQ_KEYS?.ANNUAL_FORECAST_MANDATORY && (_.isEmpty(sopQuantityList) || !hasNonZeroQuantity)) {
                Toaster.warning("Select SOP date and fill the first year's quantity.");
                return false;
            }

            // Enhanced validation for plant selection - applies to Component, Tooling, and Assembly (both single and multi-plant modes)
            if (partType === "Component" || partType === "Tooling" || partType === "Assembly") {
                // Get all available plants from the plant prop (these are the plants selected outside the drawer)
                const availablePlants = isPlantMultiSelectEnabled()
                    ? (Array.isArray(plant) ? plant : [])
                    : (plant && plant.value ? [plant] : []);

                // Only validate if there are available plants
                if (availablePlants && availablePlants.length > 0) {
                    // Check if SOP quantity list is empty or has no data
                    if (RFQ_KEYS?.ANNUAL_FORECAST_MANDATORY && (_.isEmpty(sopQuantityList))) {
                        Toaster.warning(`Please add SOP quantity details for all ${availablePlants.length} plant(s).`);
                        return;
                    }

                    if (RFQ_KEYS?.ANNUAL_FORECAST_MANDATORY && (!hasNonZeroQuantity)) {
                        Toaster.warning("Please fill at least the first year's quantity for all plants.");
                        return;
                    }

                    // Get unique plant IDs from sopQuantityList that have been added to the table
                    const plantsInTable = [...new Set(sopQuantityList.map(item => item.PlantId))].filter(Boolean);

                    // Check if all available plants have SOP quantity details (for both add and edit mode)
                    const missingPlants = availablePlants.filter(p => !plantsInTable.includes(p.value));

                    if (missingPlants.length > 0) {
                        const missingPlantNames = missingPlants.map(p => p.label).join(', ');
                        Toaster.warning(`Please add hit rate for all plants: ${missingPlantNames}`);
                        return;
                    }

                    // Validate that at least the first year's quantity is filled for each plant
                    const plantsWithoutQuantity = [];
                    plantsInTable.forEach(plantId => {
                        const plantRows = sopQuantityList.filter(row => row.PlantId === plantId);
                        // Check if at least one row (preferably first year) has non-zero quantity
                        const hasQuantity = plantRows.some(row => row.Quantity && row.Quantity !== 0 && row.Quantity !== '0');
                        if (!hasQuantity) {
                            const plantObj = availablePlants.find(p => p.value === plantId);
                            if (plantObj) {
                                plantsWithoutQuantity.push(plantObj.label);
                            }
                        }
                    });

                    if (RFQ_KEYS?.ANNUAL_FORECAST_MANDATORY && (plantsWithoutQuantity.length > 0)) {
                        Toaster.warning(`Please fill at least the first year's quantity for: ${plantsWithoutQuantity.join(', ')}`);
                        return;
                    }
                }
            }

            // Hit Rate Per Day validation for Component and Tooling
            if ((partType === "Component" || partType === "Tooling") && RFQ_KEYS?.SHOW_HITRATEPERDAY_FIELD && (hitRatePerDay === '' || hitRatePerDay === null || hitRatePerDay === undefined)) {
                Toaster.warning("Please fill the Hit Rate Per Day.");
                return;
            }

            // Specification validation
            if (RFQ_KEYS?.SPECIFICATION_MANDATORY && (specificationList && specificationList?.length === 0)) {
                Toaster.warning("Please fill the Specification Details.");
                return;
            }

        }

        if (RFQ_KEYS?.REMARKS_ATTACHMENT_MANDATORY && (getValues('remark') === '' || files.length === 0)) {
            Toaster.warning('Please fill the remarks and attachments documents.');
            return;
        }


        props?.closeDrawer('', true, {
            hitRatePerDay,
            sopQuantityList,
            selectedPlants: selectedPlantForVolume
        });
        if (props?.setViewQuotationPart && typeof props.setViewQuotationPart === 'function') {
            props.setViewQuotationPart(false);
        }

        // Save to Redux based on part type - DO NOT CLEAR BEFORE SAVING!
        if (partType === "Raw Material") {
            const attachment = files;
            const updatedRemark = getValues('remark') || null;

            if (Array.isArray(rmSpecificRowData) && rmSpecificRowData.length > 0) {
                const updatedObject = {
                    ...rmSpecificRowData[0],
                    Attachments: attachment,
                    Remarks: updatedRemark
                };
                const updatedArray = [updatedObject];
                dispatch(setRmSpecificRowData(updatedArray));
            }
        } else if (partType === "Bought Out Part") {
            const attachment = files;
            const updatedRemark = getValues('remark') || null;
            const specification = specificationList

            if (Array.isArray(bopSpecificRowData) && bopSpecificRowData.length > 0) {
                const updatedObject = {
                    ...bopSpecificRowData[0],
                    Attachments: attachment,
                    Remarks: updatedRemark,
                    PartSpecification: specification
                };
                const updatedArray = [updatedObject];
                dispatch(setBopSpecificRowData(updatedArray));
            }
        } else if (partType === "Component" || partType === "Assembly") {
            const attachment = files;
            const updatedRemark = getValues('remark') || null;
            const specification = specificationList;
            const sopQuantityDetails = sopQuantityList || [];
            const rmDetails = tableData || [];
            const hitRate = getValues('HitRatePerDay');

            // Build PartList - either update existing or create new
            let updatedPartList = [];

            if (getRfqPartDetails && getRfqPartDetails.PartList && getRfqPartDetails.PartList.length > 0) {
                // Edit mode - update existing PartList
                updatedPartList = getRfqPartDetails.PartList.map((part, index) => {
                    if (index === 0) {
                        return {
                            ...part,
                            Attachments: attachment,
                            Remarks: updatedRemark,
                            PartSpecification: specification,
                            SOPQuantityDetails: sopQuantityDetails,
                            HitRatePerDay: hitRate,
                            RMDetails: rmDetails.filter(rm => rm.PartId === part.PartId),
                            SOPDate: sopdate || part.SOPDate
                        };
                    }
                    return {
                        ...part,
                        RMDetails: rmDetails.filter(rm => rm.PartId === part.PartId)
                    };
                });
            } else {
                // Fresh add mode - create new PartList structure
                updatedPartList = [{
                    PartId: AssemblyPartNumber?.value || '',
                    PartNumber: AssemblyPartNumber?.label || '',
                    Attachments: attachment,
                    Remarks: updatedRemark,
                    PartSpecification: specification,
                    SOPQuantityDetails: sopQuantityDetails,
                    HitRatePerDay: hitRate,
                    RMDetails: rmDetails,
                    SOPDate: sopdate || ''
                }];
            }

            dispatch(setRfqPartDetails({
                ...getRfqPartDetails,
                PartList: updatedPartList
            }));
        } else if (partType === "Tooling") {
            const attachment = files;
            const updatedRemark = getValues('remark') || null;
            const specification = specificationList

            if (Array.isArray(toolingSpecificRowData) && toolingSpecificRowData.length > 0) {
                const updatedObject = {
                    ...toolingSpecificRowData[0],
                    Attachments: attachment,
                    Remarks: updatedRemark,
                    PartSpecification: specification
                };
                const updatedArray = [updatedObject];
                dispatch(setToolingSpecificRowData(updatedArray));
            }
        }

        // Clear Redux for next fresh add operation - only after saving
        // Note: Don't clear here if you want data to persist for edit mode
        // dispatch(setRfqPartDetails({}));



    }
    const cancelUpdate = () => {
        setIsEdit(false);
        setEditIndex(null);  // Clear editIndex when canceling
        // setTableData([]);
        // setSpecificationList([]);
        resetFormAndDropdowns();
    };

    /**
      * @method deleteRow
      * @description Deleting single row from table
      */
    const deleteRow = (index, activeTab) => {
        // Clear edit state when deleting to avoid stale editIndex
        setIsEdit(false);
        setEditIndex(null);
        resetFormAndDropdowns(true);

        if (activeTab === "2") {
            const newSpecificationList = [...specificationList];
            newSpecificationList.splice(index, 1);
            setSpecificationList(newSpecificationList);
        } else {
            if (type === Component || type === BoughtOutPart) {
                setValue('partNumber', { label: AssemblyPartNumber.label, value: AssemblyPartNumber.value })
            }
            const tempObj = tableData[index];
            const removedItemPartNumber = tempObj.PartId;
            const newData = [...tableData];
            newData.splice(index, 1);
            setTableData(newData);
            setSelectedValues(prevSelected => prevSelected.filter(value => value !== removedItemPartNumber));
        }
    };
    /**
     * @method editRow
     * @description for filling the row above table for editing
     */
    const editRow = (index, activeTab) => {
        setIsEdit(true);
        setEditIndex(index);  // Set editIndex first for proper filtering
        if (activeTab === "2") {
            const editSpecification = specificationList[index]
            setValue('Specification', editSpecification.Specification);
            setValue('Value', editSpecification.Value);
        } else {
            const tempObj = tableData[index];
            // Set both form values and state for consistent behavior
            setValue('partNumber', { label: tempObj.PartNumber, value: tempObj.PartId });
            setChildPart({ label: tempObj.PartNumber, value: tempObj.PartId });
            setValue('RMName', { label: tempObj.RawMaterialName, value: tempObj.RawMaterialChildId });
            setRMName({ label: tempObj.RawMaterialName, value: tempObj.RawMaterialChildId });
            setValue('RMGrade', { label: tempObj.RawMaterialGrade, value: tempObj.RawMaterialGradeId });
            setRMGrade({ label: tempObj.RawMaterialGrade, value: tempObj.RawMaterialGradeId });
            setValue('RMSpecification', { label: tempObj.RawMaterialSpecification, value: tempObj.RawMaterialSpecificationId });
            setValue('rmcode', { label: tempObj.RawMaterialCode, value: tempObj.RawMaterialCodeId });
            setRMCode({ label: tempObj.RawMaterialCode, value: tempObj.RawMaterialCodeId });
        }
    };
    const Preview = ({ meta }) => {
        return (
            <span style={{ alignSelf: 'flex-start', margin: '10px 3%', fontFamily: 'Helvetica' }}>
                {/* {Math.round(percent)}% */}
            </span>
        )
    }

    const deleteFile = (FileId, OriginalFileName) => {
        // if (dataProps?.isAddFlag ? false : dataProps?.isViewFlag || !isEditAll) {
        //     return false
        // }
        if (FileId != null) {
            let tempArr = files.filter((item) => item.FileId !== FileId)
            setFiles(tempArr);
            setChildPartFiles(tempArr)
            setIsOpen(!IsOpen)
        }
        if (FileId == null) {
            let tempArr = files && files.filter(item => item.FileName !== OriginalFileName)
            setFiles(tempArr)
            setChildPartFiles(tempArr)
            setIsOpen(!IsOpen)
        }
        // ********** DELETE FILES THE DROPZONE'S PERSONAL DATA STORE **********
        if (dropzone?.current !== null) {
            dropzone.current.files.pop()
        }
    }
    // Helper function to determine if a row is the middle row (3rd row) of its plant group
    const isMiddleRowOfPlantGroup = (row) => {
        if (!row) return false;

        // Use RowIndexInGroup property if available (most reliable method)
        if (row.RowIndexInGroup !== undefined && row.RowIndexInGroup !== null) {
            return row.RowIndexInGroup === 2; // 3rd row (0-indexed, so index 2)
        }

        // Fallback: Try to determine from sopQuantityList
        if (!sopQuantityList || !row.PlantId) return false;

        // Get all rows for the same plant
        const allRowsForPlant = sopQuantityList.filter(r => r.PlantId === row.PlantId);

        // Sort by YearName to ensure correct order
        allRowsForPlant.sort((a, b) => a.YearName - b.YearName);

        // Find the current row index by matching YearName
        const currentIndex = allRowsForPlant.findIndex(r =>
            r.YearName === row.YearName
        );

        return currentIndex === 2; // 3rd row (0-indexed, so index 2)
    }

    const partNumberFormatter = (props) => {
        const row = props?.data;
        const value = row?.PartNumber || '';
        const isMiddleRow = isMiddleRowOfPlantGroup(row);
        
        if (value && value !== '' && isMiddleRow) {
            return <div className="font-ellipsis">{value}</div>
        } else {
            return <div className="row-merge"></div>
        }
    }
    const handleChangeStatus = ({ meta, file }, status) => {

        if (status === 'removed') {
            const removedFileName = file.name;
            let tempArr = files.filter(item => item.OriginalFileName !== removedFileName);
            setFiles(tempArr);
            setChildPartFiles(tempArr)
            setIsOpen(prevState => !prevState);
        }

        if (status === 'done') {
            let data = new FormData()
            data.append('file', file)
            if (!validateFileName(file.name)) {
                dropzone.current.files.pop()
                //setDisableFalseFunction()
                return false;
            }
            setApiCallCounter(prevCounter => prevCounter + 1);  // Increment the API call counter for loader showing
            setAttachmentLoader(true);
            setIsDisable(true)
            dispatch(fileUploadQuotation(data, (res) => {

                if ('response' in res) {
                    status = res?.response?.status;
                    dropzone.current.files.pop();
                    setAttachmentLoader(false);
                } else {
                    let Data = res?.data[0];

                    setFiles(prevFiles => [...prevFiles, Data]); // Update the state using the callback function
                    setChildPartFiles(prevFiles => [...prevFiles, Data]);
                    setAttachmentLoader(false)

                }
                setApiCallCounter(prevCounter => prevCounter - 1);

                // Check if this is the last API call after decrement
                if (apiCallCounter - 1 === 0) {
                    setAttachmentLoader(false);
                    setIsDisable(false);
                    setTimeout(() => {
                        setIsOpen(prevState => !prevState);
                    }, 500);
                }
            }));
        }

        if (status === 'rejected_file_type') {
            Toaster.warning('Allowed only xls, doc, docx, pptx jpeg, pdf, zip files.');
        } else if (status === 'error_file_size') {
            setAttachmentLoader(false);
            dropzone.current.files.pop();
            Toaster.warning("File size greater than 20 mb not allowed");
        } else if (['error_validation', 'error_upload_params', 'exception_upload', 'aborted', 'error_upload'].includes(status)) {
            setAttachmentLoader(false);
            dropzone.current.files.pop();
            Toaster.warning("Something went wrong");
        }
    };
    const buttonFormatterFirst = (props) => {
        let final = _.map(props?.node?.rowModel?.rowsToDisplay, 'data')
        let show = (props?.data?.PartNumber === undefined) ? false : true
        const row = props?.data;
        return (
            <>
                {/* {show && < button title='Edit' className="Edit mr-2 align-middle" disabled={dataProps?.isAddFlag ? false : (dataProps?.isViewFlag || !isEditAll)} type={'button'} onClick={() => editItemPartTable(props?.agGridReact?.gridOptions?.rowData, props, true)} />}
                {show && <button title='Delete' className="Delete align-middle" disabled={dataProps?.isAddFlag ? false : (dataProps?.isViewFlag || !isEditAll)} type={'button'} onClick={() => deleteItemPartTable(row, final)} />} */}
            </>
        )
    };

    const cellClass = (props) => {
        return `${props?.data?.LastRow ? `border-color` : ''} ${props?.data?.RowMargin} colorWhite`          // ADD SCSS CLASSES FOR ROW MERGING
    }

    const separatorCellClass = (props) => {
        // Add bottom border to last row of each plant group to visually separate plants
        return `${props?.data?.LastRow ? `plant-separator-border border-bottom` : 'border-bottom'} colorWhite border-bottom`
    }

    const partNoCellClass = (props) => {
        // Add border grouping for Part No column
        return `${props?.data?.LastRow ? `plant-separator-border` : ''} part-no-cell colorWhite`
    }

    const plantCodeCellClass = (props) => {
        // Add border grouping for Plant Code column
        return `${props?.data?.LastRow ? `plant-separator-border` : ''} plant-code-cell colorWhite`
    }

    const hitRateFormatter = (props) => {
        const row = props?.data;
        const value = row?.HitRatePerDay || '';
        const isMiddleRow = isMiddleRowOfPlantGroup(row);

        if (value && value !== '' && isMiddleRow) {
            return <div className="font-ellipsis">{value}</div>
        } else {
            return <div className="row-merge"></div>
        }
    }

    // New formatter for Actions column with Edit and Delete buttons
    const actionsFormatter = (props) => {
        const row = props?.data;
        const isMiddleRow = isMiddleRowOfPlantGroup(row);

        if (isMiddleRow && !isViewFlag) {
            return (
                <div className="d-flex align-items-center">
                    <button
                        className="Edit mr-2"
                        type="button"
                        title="Edit"
                        onClick={() => handleEditPlantRow(row)}
                        disabled={isViewFlag}
                    />
                    <button
                        className="Delete"
                        type="button"
                        title="Delete"
                        onClick={() => handleDeletePlantRow(row)}
                        disabled={isViewFlag || isDeleting}
                    />
                </div>
            );
        } else {
            return <div className="row-merge"></div>;
        }
    }

    const hitRateCellClass = (props) => {
        // Add border grouping for Hit Rate Per Day column
        return `${props?.data?.LastRow ? `plant-separator-border` : ''} plant-code-cell colorWhite`
    }

    const actionsCellClass = (props) => {
        // Add border grouping for Actions column
        return `${props?.data?.LastRow ? `plant-separator-border` : ''} colorWhite`
    }

    const onGridReady = (params) => {
        params.api.sizeColumnsToFit();
        setGridColumnApi(params.columnApi)
        setGridApi(params.api)
        params.api.paginationGoToPage(0);
        setTimeout(() => {

            setShowTooltip(true)
            }, 100);
    };

    const onCellValueChanged = (params) => {
        // When a cell value changes (user edits Quantity), update the sopQuantityList
        if (params.column.colId === 'Quantity') {
            // Get all updated data from the single grid
            const updatedData = [];
            params.api.forEachNode(node => {
                updatedData.push(node.data);
            });

            // Update the state with all data from the grid
            setSopQuantityList(updatedData);
        }
    };
    const tooltipToggle = () => {
        setViewTooltip(!viewTooltip)
    }
    const EditableCallback = (props) => {

        let value
        value = isViewFlag ? false : true


        return value
    }
    const handleCode = (newValue) => {
        if (newValue && newValue !== '') {
            setRMCode(newValue)
            // For isMultipleRMApplied = false, disable after code selection (original behavior)
            // For isMultipleRMApplied = true, don't disable - allow multiple RMs
            if (!isMultipleRMApplied) {
                setDisabled(true)
            }
            delete errors?.RawMaterialSpecification
            delete errors?.RawMaterialGrade
            delete errors.RawMaterialName
            dispatch(getRMSpecificationDataAPI(newValue.value, true, (res) => {
                if (res.status === 204) {

                    setRMGrade({ label: '', value: '', })
                    setRMSpecification({ label: '', value: '', })
                    setRMName({ label: '', value: '', })
                    Toaster.warning("The Raw Material Grade and Specification has set as unspecified. First update the Grade and Specification against this Raw Material Code from Manage Specification tab.")
                    return false
                }
                let Data = res?.data?.Data

                setRMGrade({ label: Data.GradeName, value: Data.GradeId })
                setRMSpecification({ label: Data.Specification, value: Data.SpecificationId })
                setRMName({ label: Data.RawMaterialName, value: Data.RawMaterialId, })
                setValue('RMName', { label: Data.RawMaterialName, value: Data.RawMaterialId, })
                setValue('RMGrade', { label: Data.GradeName, value: Data.GradeId })
                setValue('RMSpecification', { label: Data.Specification, value: Data.SpecificationId })
            }))
        } else {
            setValue('RMName', '')
            setValue('RMGrade', '')
            setValue('RMSpecification', '')
            setDisabled(false)

        }
    }
    // const quantityHeader = (props) => {
    //     return (
    //         <div className='ag-header-cell-label'>
    //             <span className='ag-header-cell-text d-flex'>Annual Forecast Quantity<i className={`fa fa-info-circle tooltip_custom_right tooltip-icon mb-n3 ml-4 mt2 `} id={"quantity-tooltip"}></i> </span>
    //         </div>
    //     );
    // };
    const defaultColDef = {
        resizable: true,
        filter: true,
        sortable: false,
        suppressRowTransform: true,
        suppressAutoSize: true,
    };
    // const buttonFormatterVendorTable = (props) => {
    //     return (
    //         <>
    //             {<button title='Delete' className="Delete align-middle" type={'button'} disabled={isEditFlag ? true : isViewFlag ? false : true} onClick={() => deleteItemVendorTable(props?.agGridReact?.gridOptions.rowData, props)} />}
    //         </>
    //     )
    // }
    const beforeSaveCell = (props) => {
        let cellValue = props
        if (cellValue === undefined) {
            return true
        }
        if (cellValue && !/^[0-9]+(\.[0-9]+)?$/.test(cellValue)) {
            Toaster.warning('Please enter a valid positive number.');
            return false;
        }
        return true
    }
    const sopFormatter = (props) => {

        const cellValue = props?.value;
        return cellValue ? cellValue : '-'
    }

    const plantCodeFormatter = (props) => {
        const row = props?.data;
        const value = row?.PlantCode || '';
        const isMiddleRow = isMiddleRowOfPlantGroup(row);
        
        if (value && value !== '' && isMiddleRow) {
            return <div className="font-ellipsis">{value}</div>
        } else {
            return <div className="row-merge"></div>
        }
    }
    const afcFormatter = (props) => {
        const cell = props?.value;
        const value = beforeSaveCell(cell)

        let isEnable
        isEnable = isEditFlag ? true : isViewFlag ? false : true

        return (
            <>
                {<span className={`form-control custom-max-width-110px  ${isEnable ? '' : 'disabled'}`} >{value ? Number(cell) : 0}</span>}
            </>
        )
    }
    function getNextFiveYears(currentYear) {
        const years = [];
        for (let i = 0; i < 5; i++) {
            years.push(currentYear + i);
        }
        return years;
    }

    // Function to handle editing a plant row
    const handleEditPlantRow = (row) => {
        // Set editing mode with the current row's plant info
        setEditingPlantRow(row.PlantId);

        // Populate the existing form fields (HitRatePerDay and PlantCode)
        setHitRate(row.HitRatePerDay || '');
        
        // Set form values to show in the inputs
        setValue('HitRatePerDay', row.HitRatePerDay || '');
        
        // Handle plant selection based on multi-select mode
        if (isPlantMultiSelectEnabled()) {
            // Multi-select mode: Find the plant object from selectedPlantForVolume
            const plantObj = selectedPlantForVolume.find(p => p.value === row.PlantId);
            
            if (plantObj) {
                // Set both state and form value
                setSelectedPlant(plantObj);
                
                // Force the form to update by clearing first, then setting the value
                setValue('PlantCode', null);
                
                // Use requestAnimationFrame to ensure the value is set after the component re-renders
                requestAnimationFrame(() => {
                    setValue('PlantCode', plantObj);
                });
            }
        } else {
            // Single-select mode: Always use the main plant
            if (plant && plant.value) {
                setSelectedPlant(plant);
                setValue('PlantCode', null);
                requestAnimationFrame(() => {
                    setValue('PlantCode', plant);
                });
            }
        }
    }

    // Function to cancel editing
    const handleCancelEditPlantRow = () => {
        setEditingPlantRow(null);

        // Clear the form fields
        setHitRate('');
        setSelectedPlant(null);
        setValue('HitRatePerDay', '');
        setValue('PlantCode', null);
    }

    // Function to handle deleting a plant row (all 5 rows for that plant)
    const handleDeletePlantRow = (row) => {
        const plantIdToDelete = row.PlantId;
        // Set flag to prevent useEffect from running during delete
        isDeletingPlant.current = true;

        // Remove all rows for this plant from sopQuantityList
        const updatedSopList = sopQuantityList.filter(item => item.PlantId !== plantIdToDelete);
        // Recalculate PlantIndex for remaining plants
        const uniquePlantIds = [...new Set(updatedSopList.map(item => item.PlantId))];
        const reindexedSopList = updatedSopList.map(item => {
            const newPlantIndex = uniquePlantIds.indexOf(item.PlantId);
            const isLastRowOfPlant = updatedSopList.filter(r => r.PlantId === item.PlantId).pop() === item;
            return {
                ...item,
                PlantIndex: newPlantIndex,
                LastRow: isLastRowOfPlant
            };
        });

        // Remove the plant from selectedPlantForVolume
        const updatedSelectedPlants = selectedPlantForVolume.filter(p => p.value !== plantIdToDelete);
        // Update all states together to avoid race conditions
        // Use functional updates to ensure we're working with the latest state
        setSopQuantityList(prevList => {
            const filtered = prevList.filter(item => item.PlantId !== plantIdToDelete);
            const uniquePlantIds = [...new Set(filtered.map(item => item.PlantId))];
            return filtered.map(item => {
                const newPlantIndex = uniquePlantIds.indexOf(item.PlantId);
                const isLastRowOfPlant = filtered.filter(r => r.PlantId === item.PlantId).pop() === item;
                return {
                    ...item,
                    PlantIndex: newPlantIndex,
                    LastRow: isLastRowOfPlant
                };
            });
        });

        setSelectedPlantForVolume(prevPlants => prevPlants.filter(p => p.value !== plantIdToDelete));
        // Clear edit mode if we were editing this plant
        if (editingPlantRow === plantIdToDelete) {
            setEditingPlantRow(null);
        }
        // Clear all form fields (Hit Rate and Plant Code)
        setHitRate('');
        setSelectedPlant(null);
        setValue('HitRatePerDay', '');
        setValue('PlantCode', '');

        // Reset the flag after a short delay to allow state updates to complete
        setTimeout(() => {
            isDeletingPlant.current = false;
        }, 100);

        Toaster.success(`Plant ${row.PlantCode} deleted successfully`);
    }

    // Function to handle adding/updating plant with hit rate to the table
    const handleAddPlant = () => {
        // Validation
        if (RFQ_KEYS?.ANNUAL_FORECAST_MANDATORY && (!sopdate)){
            Toaster.warning("Please select SOP date first");
            return;
        }
        // Only validate Hit Rate if the field is enabled
        if (RFQ_KEYS?.SHOW_HITRATEPERDAY_FIELD && (!HitRate || HitRate === '')) {
            Toaster.warning("Please enter Hit Rate Per Day");
            return;
        }

        let plantToAdd = selectedPlant;

        // For single-select mode, always use the main plant
        if (!isPlantMultiSelectEnabled()) {
            // Normalize plant format for single-select mode (handle both object and array)
            plantToAdd = Array.isArray(plant) && plant.length > 0 ? plant[0] : plant;
        }

        if (!plantToAdd || (Array.isArray(plantToAdd) && plantToAdd.length === 0) || !plantToAdd?.value) {
            Toaster.warning("Please select a Plant Code");
            return;
        }

        // Check if plant already exists in the table
        const existingPlantIds = [...new Set(sopQuantityList.map(item => item.PlantId))];
        if (!editingPlantRow && existingPlantIds.includes(plantToAdd?.value)) {
            Toaster.warning("This plant has already been added to the table");
            return;
        }

        // Check if we're in edit mode
        if (editingPlantRow) {
            // UPDATE MODE: Update all rows for this plant with new Hit Rate and Plant Code
            const updatedSopList = sopQuantityList.map(row => {
                if (row.PlantId === editingPlantRow) {
                    return {
                        ...row,
                        HitRatePerDay: HitRate,
                        PlantCode: plantToAdd?.label || row.PlantCode,
                        PlantId: plantToAdd?.value || row.PlantId,
                        PartNumber: AssemblyPartNumber?.label || row.PartNumber
                    };
                }
                return row;
            });

            // Update selectedPlantForVolume if plant changed (only in multi-select mode)
            if (isPlantMultiSelectEnabled()) {
                const updatedSelectedPlants = selectedPlantForVolume.map(p => {
                    if (p.value === editingPlantRow) {
                        return plantToAdd;
                    }
                    return p;
                });
                setSelectedPlantForVolume(updatedSelectedPlants);
                setValue('PlantCode', updatedSelectedPlants);
            }

            setSopQuantityList(updatedSopList);

            // Clear edit mode and form fields
            setEditingPlantRow(null);
            setSelectedPlant(null);
            setHitRate('');
            setValue('HitRatePerDay', '');
            // Only clear PlantCode field in multi-select mode
            // In single-select mode, keep the plant displayed
            if (isPlantMultiSelectEnabled()) {
                setValue('PlantCode', null);
            }

            Toaster.success("Plant details updated successfully");
        } else {
            // ADD MODE: Add new plant to the table
            // Calculate years from sopdate
            const year = new Date(sopdate).getFullYear();
            const yearList = getNextFiveYears(year);

            // Update selectedPlantForVolume based on mode
            if (isPlantMultiSelectEnabled()) {
                // Multi-select mode: add new plant to array
                const updatedSelectedPlants = [...selectedPlantForVolume, plantToAdd];
                setSelectedPlantForVolume(updatedSelectedPlants);
                setValue('PlantCode', updatedSelectedPlants);
            } else {
                // Single-select mode: ensure selectedPlantForVolume contains the plant
                if (selectedPlantForVolume.length === 0) {
                    setSelectedPlantForVolume([plantToAdd]);
                }
            }

            // Validate plantToAdd has required properties before creating rows
            if (!plantToAdd.label || !plantToAdd.value) {
                Toaster.error("Invalid plant data. Please select a valid plant.");
                return;
            }

            // Generate data for the newly added plant
            let newPlantData = [];
            const plantIdx = isPlantMultiSelectEnabled() ? selectedPlantForVolume.length : 0; // Index of newly added plant

            sopObjectTemp.forEach((item, index) => {
                let newObjTemp = {};
                // Every row should have PartNumber, PlantCode, and HitRatePerDay for Redux storage
                newObjTemp.PartNumber = AssemblyPartNumber?.label || '';
                newObjTemp.PlantCode = plantToAdd?.label || '';
                newObjTemp.PlantId = plantToAdd?.value || '';
                newObjTemp.PlantValue = plantToAdd?.value || '';
                newObjTemp.HitRatePerDay = HitRate;
                newObjTemp.SOPDate = sopdate;
                newObjTemp.PlantIndex = Number(plantIdx);
                newObjTemp.RowIndexInGroup = index; // Track row position within plant group (0-4)
                newObjTemp.Quantity = 0;
                newObjTemp.YearName = yearList[index];
                newObjTemp.isEdit = true;
                // Mark last row of each plant group for separator line
                if (index === sopObjectTemp.length - 1) {
                    newObjTemp.LastRow = true;
                }
                newPlantData.push(newObjTemp);
            });

            // Update sopQuantityList - remove LastRow from previous last plant and add new data
            const updatedSopList = sopQuantityList.map((row, idx) => {
                // Remove LastRow from all existing rows first
                return { ...row, LastRow: false };
            });

            // Add new plant data
            const finalSopList = [...updatedSopList, ...newPlantData];

            // Set LastRow for the last row of each plant group
            const finalDataWithLastRow = finalSopList.map((row, index) => {
                const isLastRowOfPlant = index === finalSopList.length - 1 ||
                    (index < finalSopList.length - 1 && finalSopList[index + 1].PlantId !== row.PlantId);
                return { ...row, LastRow: isLastRowOfPlant };
            });

            setSopQuantityList(finalDataWithLastRow);

            // Clear temporary selections
            setSelectedPlant(null);
            setHitRate('');
            setValue('HitRatePerDay', '');
            // Only clear PlantCode field in multi-select mode
            // In single-select mode, keep the plant displayed
            if (isPlantMultiSelectEnabled()) {
                setValue('PlantCode', null);
            }

            Toaster.success("Plant added successfully");
        }
    }
    const handleSOPDateChange = (value) => {
        const formattedDate = DayTime(value).format('YYYY-MM-DD HH:mm:ss');

        // Validate that selected date is after N-100 date
        if (props.n100Date && value < props.n100Date) {
            Toaster.warning("SOP date must be after N-100 date");
            return;
        }
        // Update both local and parent state
        setSOPDate(formattedDate);
        setSopDate(value);



        let year = new Date(value).getFullYear()
        const yearList = getNextFiveYears(year)
        setIsNewDate(true)
        setFiveyearList(yearList)
        // setSOPDate(DayTime(value).format('YYYY-MM-DD HH:mm:ss'))
    }
    function shouldShowButtons(activeTab, propsPartType) {
        if (propsPartType === 'Tooling') {
            return !(activeTab === 1 || activeTab === 3 || activeTab === 4);
        }

        if (propsPartType === "Component") {
            return activeTab === 1 || activeTab === 2 || activeTab === 5;
        }

        return true;
    }
    function shouldShowTableButtons(activeTab, propsPartType) {
        if (propsPartType === 'Tooling') {
            return Number(activeTab) === 2;
        }

        if (propsPartType === "Component") {
            return activeTab === 1 || activeTab === 2;
        }
        if (propsPartType === "Bought Out Part") {
            return activeTab === 2;
        }

        return false;

    }
    const frameworkComponents = {
        buttonFormatterFirst: buttonFormatterFirst,
        customNoRowsOverlay: NoContentFound,
        sopFormatter: sopFormatter,
        EditableCallback: EditableCallback,
        afcFormatter: afcFormatter,
        plantCodeFormatter: plantCodeFormatter,
        hitRateFormatter: hitRateFormatter,
        partNumberFormatter: partNumberFormatter,
        actionsFormatter: actionsFormatter, // Add actions formatter
        // quantityHeader: quantityHeader
    };

    return (
        <>
            <Drawer className="top-drawer approval-workflow-drawer" anchor={anchor} open={isOpen} onClose={(e) => toggleDrawer(e)}>
                <div className="container-fluid ">
                    <div className={'drawer-wrapper drawer-1500px'}>

                        <Row className="drawer-heading sticky-top-0">
                            <Col>
                                <div className={'header-wrapper left'}>
                                    <h3> {partType === "Raw Material" ? "Add Remark & Attachment" : (partType === "Component" || partType === "Bought Out Part" ? "Add RM & Specification" : "Add Specification & Attachment")}</h3>
                                </div>

                                <div
                                    onClick={(e) => toggleDrawer(e)}
                                    className={'close-button right'}
                                ></div>
                            </Col>
                        </Row>
                        <Nav tabs className="subtabs cr-subtabs-head ">
                            {(props?.partType === 'Component' || props?.partType === 'Tooling') && <NavItem>
                                <NavLink
                                    className={classnames({ active: activeTab === "1" })}
                                    onClick={() => setActiveTab("1")
                                    }
                                >
                                    RM
                                </NavLink>
                            </NavItem>}
                            {(props?.partType !== 'Raw Material' || props?.partType === 'Bought Out Part' || props?.partType === 'Tooling') && <NavItem>
                                <NavLink
                                    className={classnames({ active: activeTab === "2" })}
                                    onClick={() => setActiveTab("2")
                                    }
                                >
                                    {props?.partType === 'Tooling' ? 'Tooling Specification' : ' Specification'}
                                </NavLink>
                            </NavItem>}
                            {(props?.partType === 'Tooling') && <NavItem>
                                <NavLink
                                    className={classnames({ active: activeTab === "3" })}
                                    onClick={() => setActiveTab("3")
                                    }
                                >
                                    Tooling Details
                                </NavLink>
                            </NavItem>}
                            {(props?.partType === 'Tooling') && <NavItem>
                                <NavLink
                                    className={classnames({ active: activeTab === "4" })}
                                    onClick={() => setActiveTab("4")
                                    }
                                >
                                    Part Details
                                </NavLink>
                            </NavItem>}
                            <NavItem>
                                <NavLink
                                    className={classnames({ active: activeTab === "5" })}
                                    onClick={() => setActiveTab("5")
                                    }
                                >
                                    Remarks & Attachments                                </NavLink>
                            </NavItem>
                        </Nav>
                        <TabContent activeTab={activeTab}>
                            {Number(activeTab) === 1 && (
                                <TabPane tabId="1">
                                    {props.partType !== 'Tooling' && (
                                        <>
                                            <HeaderTitle title={'Add RM'} customClass="mt-3" />

                                            <Row className="mt-1 part-detail-wrapper">
                                                <Col md="3">
                                                    <div className='mt5 flex-grow-1'>
                                                        <TooltipCustom id="RMDetail_Info" tooltipText="Select RM Name, RM Grade & specification to get the Part code, or directly input the RM Code to fetch the previously mentioned information and click on the Add button." />
                                                        <SearchableSelectHookForm
                                                            label={"Part No"}
                                                            name={"partNumber"}
                                                            placeholder={"Select"}
                                                            Controller={Controller}
                                                            control={control}
                                                            rules={{ required: RFQ_KEYS?.RM_MANDATORY ? true : false }}
                                                            register={register}
                                                            mandatory={RFQ_KEYS?.RM_MANDATORY ? true : false}

                                                            handleChange={(newValue) => handleChildPart(newValue)}
                                                            errors={errors.partNumber}
                                                            disabled={(isViewFlag || type === Component || type === BoughtOutPart || ((partTypeInPartList === "Assembly" || type === Assembly) && (
                                                                !renderListingRM('childPartName') ||
                                                                renderListingRM('childPartName')?.length === 0
                                                            ))) ? true : false}
                                                            isLoading={plantLoaderObj}
                                                            options={renderListingRM('childPartName')}
                                                        />
                                                    </div>
                                                </Col>

                                                <Col md="3">
                                                    <SearchableSelectHookForm
                                                        label="RM Name"
                                                        name={"RMName"}
                                                        placeholder={"Select"}
                                                        Controller={Controller}
                                                        control={control}
                                                        selected={rmName ? rmName : ''}
                                                        rules={{ required: RFQ_KEYS?.RM_MANDATORY ? true : false }}
                                                        register={register}
                                                        customClassName="costing-version"
                                                        options={renderListingRM('rmname')}
                                                        mandatory={RFQ_KEYS?.RM_MANDATORY ? true : false}
                                                        handleChange={(newValue) => handleRMName(newValue)}
                                                        disabled={isMultipleRMApplied
                                                            ? (disabled || isViewFlag || !getValues('partNumber')?.value)
                                                            : (disabled || isViewFlag || (editIndex !== null ? false : (
                                                                partTypeInPartList === 'Assembly' && getChildParts?.length > 0
                                                                    ? tableData.length >= getChildParts?.length
                                                                    : tableData.some(item => item.PartId === childPart?.value)
                                                            )))
                                                        }
                                                    />
                                                </Col>

                                                <Col md="3">
                                                    <SearchableSelectHookForm
                                                        label="RM Grade"
                                                        name={"RMGrade"}
                                                        placeholder={"Select"}
                                                        Controller={Controller}
                                                        control={control}
                                                        selected={rmgrade ? rmgrade : ''}
                                                        rules={{ required: getValues('RMName') ? true : false }}
                                                        register={register}
                                                        customClassName="costing-version"
                                                        options={renderListingRM('rmgrade')}
                                                        mandatory={getValues('RMName') ? true : false}
                                                        handleChange={(newValue) => handleRMGrade(newValue)}
                                                        disabled={isMultipleRMApplied
                                                            ? (disabled || isViewFlag || !getValues('partNumber')?.value)
                                                            : (disabled || isViewFlag || (editIndex !== null ? false : (
                                                                partTypeInPartList === 'Assembly' && getChildParts?.length > 0
                                                                    ? tableData.length >= getChildParts?.length
                                                                    : tableData.some(item => item.PartId === childPart?.value)
                                                            )))
                                                        }
                                                    />
                                                </Col>

                                                <Col md="3">
                                                    <SearchableSelectHookForm
                                                        label="RM Specification"
                                                        name={"RMSpecification"}
                                                        placeholder={"Select"}
                                                        Controller={Controller}
                                                        control={control}
                                                        selected={rmspecification ? rmspecification : ''}
                                                        rules={{ required: getValues('RMName') ? true : false }}
                                                        register={register}
                                                        customClassName="costing-version"
                                                        options={renderListingRM('rmspecification')}
                                                        mandatory={getValues('RMName') ? true : false}
                                                        handleChange={(newValue) => handleRMSpecification(newValue)}
                                                        disabled={isMultipleRMApplied
                                                            ? (disabled || isViewFlag || !getValues('partNumber')?.value)
                                                            : (disabled || isViewFlag || (editIndex !== null ? false : (
                                                                partTypeInPartList === 'Assembly' && getChildParts?.length > 0
                                                                    ? tableData.length >= getChildParts?.length
                                                                    : tableData.some(item => item.PartId === childPart?.value)
                                                            )))
                                                        }
                                                    />
                                                </Col>

                                                <Col md="3" className='d-flex align-items-center'>
                                                    <SearchableSelectHookForm
                                                        label={"Code"}
                                                        name={"rmcode"}
                                                        placeholder={'Select'}
                                                        options={renderListingRM("rmcode")}
                                                        Controller={Controller}
                                                        control={control}
                                                        register={register}
                                                        rules={{ required: getValues('RMName') ? true : false }}
                                                        mandatory={getValues('RMName') ? true : false}
                                                        handleChange={handleCode}
                                                        isClearable={true}
                                                        errors={errors.Code}
                                                        disabled={isMultipleRMApplied
                                                            ? (disabled || isViewFlag || !getValues('partNumber')?.value)
                                                            : (disabled || isViewFlag || (editIndex !== null ? false : (
                                                                partTypeInPartList === 'Assembly' && getChildParts?.length > 0
                                                                    ? tableData.length >= getChildParts?.length
                                                                    : tableData.some(item => item.PartId === childPart?.value)
                                                            )))
                                                        }
                                                    />
                                                </Col>
                                                {shouldShowTableButtons(Number(activeTab), props.partType) && (
                                                    <>
                                                        <Col md="3" className='mb-3 d-flex align-items-center pb-1'>
                                                            <div className='ml-1 mt5'> {/* Add margin to separate the reset button */}
                                                                {isEdit ? (
                                                                    <>
                                                                        <button
                                                                            type="button"
                                                                            className={'btn btn-primary mt30 pull-left mr5'}
                                                                            onClick={() => addRow(activeTab)}
                                                                        >
                                                                            Update
                                                                        </button>

                                                                        <button
                                                                            type="button"
                                                                            className="mt30 cancel-btn"
                                                                            onClick={() => cancelUpdate()}
                                                                        >
                                                                            <div className={"cancel-icon"}></div>
                                                                            Cancel
                                                                        </button>
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <button
                                                                            type="button"
                                                                            className={'user-btn mt30 pull-left'}
                                                                            onClick={() => addRow(activeTab)}
                                                                            disabled={isMultipleRMApplied
                                                                                ? (isViewFlag || disabled || !getValues('partNumber')?.value)
                                                                                : (isViewFlag || (!isEditFlag ? (type === Component && activeTab === "1" ? tableData.length > 0 : false) : false))
                                                                            }
                                                                        >
                                                                            <div className={'plus'}></div>
                                                                            ADD
                                                                        </button>
                                                                        <button
                                                                            type="button"
                                                                            className={"mr15 ml-1 mt30 reset-btn"}
                                                                            disabled={isMultipleRMApplied
                                                                                ? (isViewFlag || disabled || !getValues('partNumber')?.value)
                                                                                : (isViewFlag || (!isEditFlag ? (type === Component && activeTab === "1" ? tableData.length > 0 : false) : false))
                                                                            }
                                                                            onClick={rateTableReset}
                                                                        >
                                                                            Reset
                                                                        </button>
                                                                    </>
                                                                )}
                                                            </div>
                                                        </Col>
                                                    </>
                                                )}
                                            </Row>
                                        </>
                                    )}
                                </TabPane>
                            )}

                            {Number(activeTab) === 2 && (
                                <TabPane tabId="2">


                                    <HeaderTitle title={'Add Specification'} customClass="mt-3" />
                                    {/* <TooltipCustom id="addSpecification" customClass="mt-3" tooltipText="Describe comprehensive specifications, desired features, quality standard and any other relevant details to ensure supplier understand needs." /> */}


                                    <div className="tab-pane fade active show" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab">
                                        <Row>
                                            <Col md="3">
                                                <AsyncSearchableSelectHookForm
                                                    label={partType === "Bought Out Part" ? "BOP Part No" : "Assembly Part No"}
                                                    name={"AssemblyPartNumber"}
                                                    placeholder={"Select"}
                                                    Controller={Controller}
                                                    control={control}
                                                    rules={{ required: false }}
                                                    register={register}
                                                    // defaultValue={AssemblyPartNumber.length !== 0 ? AssemblyPartNumber : ""}
                                                    handleChange={() => { }}
                                                    errors={errors.AssemblyPartNumber}
                                                    disabled={true}
                                                />
                                            </Col>
                                            <Col md="3">
                                                <TooltipCustom id="Specification_Info" tooltipText="Describe comprehensive specifications, desired features, quality standards and any other relevant details to ensure the supplier understands needs." />

                                                <TextFieldHookForm
                                                    label="Specification Description"
                                                    name={"Specification"}
                                                    validate={[required, alphaNumeric, checkWhiteSpaces]}
                                                    Controller={Controller}
                                                    control={control}
                                                    selected={specification ? specification : ''}
                                                    register={register}
                                                    mandatory={RFQ_KEYS?.SPECIFICATION_MANDATORY ? true : false}
                                                    rules={{
                                                        required: RFQ_KEYS?.SPECIFICATION_MANDATORY ? true : false,
                                                        validate: { checkWhiteSpaces, acceptAllExceptSingleSpecialCharacter, maxLength100 },
                                                    }}
                                                    handleChange={(e) => handleSpecification(e.target.value)}
                                                    defaultValue={''}
                                                    className=""
                                                    customClassName={'withBorder'}
                                                    errors={errors.Specification}
                                                    disabled={isViewFlag}
                                                />
                                            </Col>
                                            <Col md="3">
                                                <TextFieldHookForm
                                                    label="Value"
                                                    name={"Value"}
                                                    validate={[required, checkWhiteSpaces]}
                                                    Controller={Controller}
                                                    control={control}
                                                    selected={valueState ? valueState : ''}
                                                    register={register}
                                                    mandatory={RFQ_KEYS?.SPECIFICATION_MANDATORY ? true : false}
                                                    rules={{
                                                        required: RFQ_KEYS?.SPECIFICATION_MANDATORY ? true : false,
                                                        validate: { checkWhiteSpaces, number, numberLimit6, decimalNumberLimit6 },
                                                    }}
                                                    handleChange={(e) => handleValue(e.target.value)}
                                                    defaultValue={''}
                                                    className=""
                                                    customClassName={'withBorder'}
                                                    errors={errors.Value}
                                                    disabled={isViewFlag}
                                                />
                                            </Col>
                                            {shouldShowTableButtons(Number(activeTab), props.partType) && (
                                                <>
                                                    <Col md="3" className='mb-3 d-flex align-items-center pb-1'>
                                                        <div className='ml-1 mt5'> {/* Add margin to separate the reset button */}
                                                            {isEdit ? (
                                                                <>
                                                                    <button
                                                                        type="button"
                                                                        className={'btn btn-primary mt30 pull-left mr5'}
                                                                        onClick={() => addRow(activeTab)}
                                                                    >
                                                                        Update
                                                                    </button>

                                                                    <button
                                                                        type="button"
                                                                        className="mt30 cancel-btn"
                                                                        onClick={() => cancelUpdate()}
                                                                    >
                                                                        <div className={"cancel-icon"}></div>
                                                                        Cancel
                                                                    </button>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <button
                                                                        type="button"
                                                                        className={'user-btn mt30 pull-left'}
                                                                        onClick={() => addRow(activeTab)}
                                                                        disabled={isViewFlag}
                                                                    >
                                                                        <div className={'plus'}></div>
                                                                        ADD
                                                                    </button>
                                                                    <button
                                                                        type="button"
                                                                        className={"mr15 ml-1 mt30 reset-btn"}
                                                                        disabled={isViewFlag}
                                                                        onClick={rateTableReset}
                                                                    >
                                                                        Reset
                                                                    </button>
                                                                </>
                                                            )}
                                                        </div>
                                                    </Col>
                                                </>
                                            )}
                                        </Row>
                                    </div>
                                </TabPane>
                            )}
                            {Number(activeTab) === 3 && partType === 'Tooling' &&
                                (<TabPane tabId="3">
                                    <AddToolingRfq />
                                </TabPane>)}
                            {Number(activeTab) === 4 && partType === 'Tooling' &&
                                (<TabPane tabId="4">
                                    <ToolingPartDetails />
                                </TabPane>)}
                            {Number(activeTab) === 5 && (<TabPane tabId="5">
                                <HeaderTitle title={'Remarks and Attachments:'} customClass="mt-3" />
                                <Row className='part-detail-wrapper'>
                                    <Col md="12">
                                        <TooltipCustom id="remark_tooltip" tooltipText="This remark is for internal reference and is not accessible to the supplier" />

                                        <TextAreaHookForm
                                            label={"Remarks"}
                                            name={"remark"}
                                            placeholder={"Type here..."}
                                            Controller={Controller}
                                            control={control}
                                            rules={{
                                                required: RFQ_KEYS?.REMARKS_ATTACHMENT_MANDATORY ? true : false,
                                                maxLength: HAVELLSREMARKMAXLENGTH,
                                            }}
                                            mandatory={RFQ_KEYS?.REMARKS_ATTACHMENT_MANDATORY ? true : false}
                                            register={register}
                                            //defaultValue={DestinationPlant.length !== 0 ? DestinationPlant : ""}
                                            // options={renderListing("DestinationPlant")}
                                            customClassName={"withBorder"}
                                            handleChange={(e) => { handleRemarkChange(e.target.value) }}
                                            errors={errors.remark}
                                            // disabled={dataProps?.isAddFlag ? false : (dataProps?.isViewFlag || !isEditAll)}
                                            rowHeight={6}
                                            disabled={isViewFlag}
                                        // isLoading={plantLoaderObj}
                                        />
                                    </Col>
                                </Row>
                                <Col md="6" className="height152-label">
                                    <label>Upload Attachment (upload up to 4 files, size of each file upto 20MB)<span className="asterisk-required">{RFQ_KEYS?.REMARKS_ATTACHMENT_MANDATORY ? "*" : ""}</span><AttachmentValidationInfo />  </label>
                                    <div className={`alert alert-danger mt-2 ${files?.length === 4 ? '' : 'd-none'}`} role="alert">
                                        Maximum file upload limit has been reached.
                                    </div>
                                    <div id="addRFQ_uploadFile" className={`${files?.length >= 4 ? 'd-none' : ''}`}>
                                        <Dropzone
                                            ref={dropzone}
                                            onChangeStatus={handleChangeStatus}
                                            PreviewComponent={Preview}
                                            accept="image/jpeg,image/jpg,image/png,image/PNG,.xls,.doc,.pdf,.xlsx,.zip, .docx,.pptx"
                                            initialFiles={[]}
                                            maxFiles={4}
                                            maxSizeBytes={20000000}  // 20 MB in bytes
                                            inputContent={(files, extra) =>
                                                extra.reject ? (
                                                    "Image, audio and video files only"
                                                ) : (
                                                    <div className="text-center">
                                                        <i className="text-primary fa fa-cloud-upload"></i>
                                                        <span className="d-block">
                                                            Drag and Drop or{" "}
                                                            <span className="text-primary">Browse</span>
                                                            <br />
                                                            file to upload
                                                        </span>
                                                    </div>
                                                )
                                            }
                                            styles={{
                                                dropzoneReject: {
                                                    borderColor: "red",
                                                    backgroundColor: "#DAA",
                                                },
                                                inputLabel: (files, extra) =>
                                                    extra.reject ? { color: "red" } : {},
                                            }}
                                            classNames="draper-drop"
                                            disabled={isViewFlag}
                                        />
                                    </div>
                                </Col>
                                <Col md="6" className='p-relative'>
                                    <div className={"attachment-wrapper"}>
                                        {attachmentLoader && <LoaderCustom customClass="attachment-loader" />}
                                        {files &&
                                            files?.map((f) => {
                                                const withOutTild = f.FileURL?.replace("~", "");
                                                const fileURL = `${FILE_URL}${withOutTild}`;
                                                return (
                                                    <div className={"attachment images"}>
                                                        <a href={fileURL} target="_blank" rel="noreferrer">
                                                            {f.OriginalFileName}
                                                        </a>
                                                        {
                                                            !isViewFlag &&
                                                            <img
                                                                alt={""}
                                                                className="float-right"
                                                                onClick={() => deleteFile(f.FileId, f.FileName)}
                                                                src={redcrossImg}
                                                            ></img>
                                                        }
                                                    </div>
                                                );
                                            })}
                                    </div>
                                </Col>
                            </TabPane>)}
                        </TabContent>
                        {Number(activeTab) !== 5 && Number(activeTab) !== 3 && Number(activeTab) !== 4 && (
                            <Col md="12">
                                <Table className="table mb-0 forging-cal-table" size="sm">
                                    <thead>
                                        <tr>
                                            {activeTab === "2" && (<th>Specification Description</th>)}
                                            {activeTab === "2" && (<th>Value</th>)}

                                            {(activeTab === "1" && props.partType !== 'Tooling') && (<th>Part Number</th>)}
                                            {(activeTab === "1" && props.partType === 'Tooling') && (<th>Part Name</th>)}
                                            {(activeTab === "1" && props.partType !== 'Tooling') && <th>Code</th>}
                                            {activeTab === "1" && (<th>RM Name</th>)}
                                            {(activeTab === "1" && props.partType !== 'Tooling') && <th>RM Grade</th>}
                                            {(activeTab === "1" && props.partType !== 'Tooling') && <th>RM Specification</th>}

                                            {props.partType !== 'Tooling' && <th>Action</th>}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {activeTab === "1" && tableData && tableData.length > 0 ? (
                                            (() => {
                                                // Sort tableData by PartId for proper grouping, keep original index for edit/delete
                                                const sortedData = tableData.map((item, originalIndex) => ({ ...item, originalIndex }))
                                                    .sort((a, b) => {
                                                        if (a.PartId < b.PartId) return -1;
                                                        if (a.PartId > b.PartId) return 1;
                                                        return 0;
                                                    });

                                                return sortedData.map((item, index) => {
                                                    // Calculate rowspan for Part Number grouping
                                                    const isFirstOfGroup = index === 0 || sortedData[index - 1]?.PartId !== item.PartId;
                                                    const rowSpan = isFirstOfGroup ? sortedData.filter(t => t.PartId === item.PartId).length : 0;

                                                    return (
                                                        <tr key={item.originalIndex}>
                                                            {props.partType !== 'Tooling' && isFirstOfGroup && (
                                                                <td rowSpan={rowSpan} style={{ verticalAlign: 'middle', fontWeight: '500' }}>
                                                                    {item.PartNumber !== null ? item.PartNumber : '-'}
                                                                </td>
                                                            )}
                                                            {props.partType === 'Tooling' && <td>{item.PartName !== null ? item.PartName : '-'}</td>}
                                                            {props.partType === 'Tooling' && <td>{item.RawMaterial !== null ? item.RawMaterial : '-'}</td>}
                                                            {props.partType !== 'Tooling' && <td>{item.RawMaterialCode !== null ? item.RawMaterialCode : '-'}</td>}
                                                            {props.partType !== 'Tooling' && <td>{item.RawMaterialName !== null ? item.RawMaterialName : '-'}</td>}
                                                            {props.partType !== 'Tooling' && <td>{item.RawMaterialGrade !== null ? item.RawMaterialGrade : '-'}</td>}
                                                            {props.partType !== 'Tooling' && <td>{item.RawMaterialSpecification !== null ? item.RawMaterialSpecification : '-'}</td>}
                                                            {props.partType !== 'Tooling' &&
                                                                <td>
                                                                    <button
                                                                        className="Edit mr-2"
                                                                        type="button"
                                                                        title="Edit"
                                                                        onClick={() => editRow(item.originalIndex, activeTab)}
                                                                        disabled={isViewFlag}
                                                                    />
                                                                    <button
                                                                        className="Delete"
                                                                        type="button"
                                                                        title="Delete"
                                                                        onClick={() => deleteRow(item.originalIndex, activeTab)}
                                                                        disabled={isViewFlag}
                                                                    />
                                                                </td>}
                                                        </tr>
                                                    );
                                                });
                                            })()
                                        ) : activeTab === "2" && specificationList && specificationList.length > 0 ? (
                                            specificationList.map((item, index) => (
                                                <tr key={index}>
                                                    <td>{item.Specification !== null ? item.Specification : '-'}</td>
                                                    <td>{item.Value !== null ? item.Value : '-'}</td>
                                                    <td>
                                                        <button
                                                            className="Edit mr-2"
                                                            type={'button'}
                                                            title='Edit'
                                                            onClick={() => editRow(index, activeTab)}
                                                            disabled={isViewFlag}
                                                        />
                                                        <button
                                                            className="Delete"
                                                            title='Delete'
                                                            type={'button'}
                                                            onClick={() => deleteRow(index, activeTab)}
                                                            disabled={isViewFlag}
                                                        />
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colspan="15">
                                                    <NoContentFound title={EMPTY_DATA} />
                                                </td>
                                            </tr>
                                        )}

                                    </tbody>
                                </Table>

                                {activeTab === "2" && (props.partType !== "Bought Out Part") && (
                                    <>
                                        <HeaderTitle title={'Add Volume'} customClass="mt-5" />
                                        <Row className='mt-3 mb-1'>
                                            <Col md="3">
                                                <div className="form-group">
                                                    <label>SOP Date<span className="asterisk-required">{RFQ_KEYS?.ANNUAL_FORECAST_MANDATORY ? "*" : ""}</span></label>
                                                    <div id="addRFQDate_container" className="inputbox date-section">
                                                        <DatePicker
                                                            name={'SOPDate'}
                                                            placeholder={'Select'}
                                                            //selected={submissionDate}
                                                            selected={DayTime(sopdate).isValid() ? new Date(sopdate) : ''}
                                                            onChange={handleSOPDateChange}
                                                            showMonthDropdown
                                                            showYearDropdown
                                                            dropdownMode='select'
                                                            // minDate={new Date()}
                                                            minDate={props.n100Date || new Date()} // SOP date must be after N-100 date
                                                            dateFormat="dd/MM/yyyy"
                                                            placeholderText="Select date"
                                                            className="withBorder"
                                                            autoComplete={"off"}
                                                            mandatory={true}
                                                            errors={errors.SOPDate}
                                                            disabledKeyboardNavigation
                                                            onChangeRaw={(e) => e.preventDefault()}
                                                            disabled={isViewFlag}
                                                        />
                                                    </div>
                                                </div>
                                            </Col>
                                            {RFQ_KEYS?.SHOW_HITRATEPERDAY_FIELD && (partType === "Bought Out Part" || partType === "Component" || partType === "Assembly") && (
                                                <Col md="3">
                                                    <div className="form-group">
                                                        <TextFieldHookForm
                                                            label="Hit Rate Per Day"
                                                            name={"HitRatePerDay"}
                                                            placeholder={"Enter"}
                                                            Controller={Controller}
                                                            control={control}
                                                            register={register}
                                                            mandatory={true}
                                                            rules={{
                                                                required: false,
                                                                validate: { number, Numeric },
                                                            }}
                                                            handleChange={(e) => {
                                                                const value = e.target.value;
                                                                if (value === '' || /^[0-9]*\.?[0-9]*$/.test(value)) {
                                                                    setHitRate(value);
                                                                    setValue('HitRatePerDay', value);
                                                                }
                                                            }}
                                                            className=""
                                                            customClassName={'withBorder'}
                                                            errors={errors.HitRatePerDay}
                                                            disabled={isViewFlag}
                                                        />
                                                    </div>
                                                </Col>

                                           )} 
                                            <Col md="3">
                                                <div className="form-group">
                                                    <SearchableSelectHookForm
                                                        key={editingPlantRow ? `edit-${editingPlantRow}` : 'add-new'} // Force re-render
                                                        label="Plant Code"
                                                        name={"PlantCode"}
                                                        placeholder={"Select Plant"}
                                                        Controller={Controller}
                                                        control={control}
                                                        register={register}
                                                        mandatory={false}
                                                        rules={{ required: false }}
                                                        handleChange={(selectPlant) => {
                                                            // Handle single plant selection
                                                            setSelectedPlant(selectPlant);
                                                            setValue('PlantCode', selectPlant);
                                                        }}
                                                        options={(() => {
                                                            // Get plant options from main form (AddRfq)
                                                            let plantOptions = [];

                                                            if (isPlantMultiSelectEnabled()) {
                                                                // Multi-select mode: plant is an array
                                                                plantOptions = Array.isArray(plant) ? plant : [];

                                                                // Get plants that are already in the current part's SOP table
                                                                const plantsInTable = [...new Set(sopQuantityList.map(item => item.PlantId))].filter(Boolean);

                                                                // When editing, include the current plant in options
                                                                if (editingPlantRow) {
                                                                    // Filter out plants already in table EXCEPT the one being edited
                                                                    return plantOptions.filter(p =>
                                                                        !plantsInTable.includes(p.value) || p.value === editingPlantRow
                                                                    );
                                                                } else {
                                                                    // When adding new, filter out plants already in THIS part's table
                                                                    // This allows the same plant to be used for different parts
                                                                    return plantOptions.filter(p => !plantsInTable.includes(p.value));
                                                                }
                                                            } else {
                                                                // Single-select mode: plant is an object, convert to array
                                                                plantOptions = plant && plant.value ? [plant] : [];
                                                                // In single-select mode, always show the single plant option
                                                                return plantOptions;
                                                            }
                                                        })()}
                                                        customClassName={'withBorder'}
                                                        errors={errors.PlantCode}
                                                        disabled={isViewFlag || !isPlantMultiSelectEnabled()}
                                                        isMulti={false}
                                                        // Show selected plant based on mode
                                                        selected={(() => {
                                                            // In single-select mode, ALWAYS show the main plant
                                                            if (!isPlantMultiSelectEnabled()) {
                                                                return plant && plant.value ? plant : null;
                                                            }
                                                            // Multi-select mode: show editing plant or temporarily selected plant
                                                            if (editingPlantRow && selectedPlant) {
                                                                return selectedPlant;
                                                            }
                                                            if (selectedPlant) {
                                                                return selectedPlant;
                                                            }
                                                            // Otherwise field should be empty (null)
                                                            return null;
                                                        })()}
                                                    />
                                                </div>
                                            </Col>
                                            <Col md="3" className='mb-3 d-flex align-items-center pb-1'>
                                                <div className='mt5'>
                                                    {editingPlantRow ? (
                                                        <>
                                                            <button
                                                                type="button"
                                                                className={'btn btn-primary mt30 pull-left mr5'}
                                                                onClick={handleAddPlant}
                                                                disabled={isViewFlag}
                                                            >
                                                                Update
                                                            </button>
                                                            <button
                                                                type="button"
                                                                className="mt30 cancel-btn"
                                                                onClick={handleCancelEditPlantRow}
                                                                disabled={isViewFlag}
                                                            >
                                                                <div className={"cancel-icon"}></div>
                                                                Cancel
                                                            </button>
                                                        </>
                                                    ) : (
                                                        <button
                                                            type="button"
                                                            className={'user-btn mt30 pull-left'}
                                                            onClick={handleAddPlant}
                                                            disabled={isViewFlag}
                                                        >
                                                            <div className={'plus'}></div>
                                                            ADD
                                                        </button>
                                                    )}
                                                </div>
                                            </Col>
                                        </Row>
                                        <div className="tab-pane fade active show" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab">
                                            {/* {showTooltip && <Tooltip className="rfq-tooltip-left" placement={"top"} isOpen={viewTooltip} toggle={tooltipToggle} target={"quantity-tooltip"} >{"To edit the quantity please double click on the field."}</Tooltip>} */}

                                            {(() => {
                                                // Use SELECTED plants from dropdown, not all plants
                                                const plantsArray = selectedPlantForVolume && selectedPlantForVolume.length > 0
                                                    ? (Array.isArray(selectedPlantForVolume) ? selectedPlantForVolume : [selectedPlantForVolume])
                                                    : [];

                                                // If no plants selected OR sopQuantityList is empty, show empty table
                                                if (plantsArray.length === 0 || !sopQuantityList || sopQuantityList.length === 0) {
                                                    return (
                                                        <Row>
                                                            <Col md="12" className='ag-grid-react'>
                                                                <div className={`ag-grid-wrapper without-filter-grid rfq-grid height-width-wrapper overlay-contain border`}>
                                                                    <div className={`ag-theme-material`}>
                                                                        <AgGridReact
                                                                            defaultColDef={defaultColDef}
                                                                            floatingFilter={false}
                                                                            domLayout='autoHeight'
                                                                            rowData={[]}
                                                                            onGridReady={onGridReady}
                                                                            onCellValueChanged={onCellValueChanged}
                                                                            customClass= "border"
                                                                            gridOptions={gridOptionsPart}
                                                                            loadingOverlayComponent="customLoadingOverlay"
                                                                            noRowsOverlayComponent="customNoRowsOverlay"
                                                                            noRowsOverlayComponentParams={{
                                                                                title: EMPTY_DATA,
                                                                                imagClass: 'imagClass ',
                                                                                customClassName: "no-content-found"
                                                                            }}
                                                                            frameworkComponents={frameworkComponents}
                                                                            suppressRowTransform={true}
                                                                            suppressColumnVirtualisation={true}
                                                                            suppressHorizontalScroll={false}
                                                                            suppressColumnMoveAnimation={true}
                                                                        >
                                                                            <AgGridColumn width={230} field="PartNumber"  headerName="Part No" tooltipField="PartNumber" cellClass={partNoCellClass} cellRenderer={'partNumberFormatter'}></AgGridColumn>
                                                                            <AgGridColumn width={230} field="YearName" headerName="Production Year" cellClass={separatorCellClass} cellRenderer={'sopFormatter'}></AgGridColumn>
                                                                            <AgGridColumn width={230} field="Quantity" headerName="Annual Forecast Quantity" cellClass={separatorCellClass} cellRenderer={'afcFormatter'} editable={EditableCallback} colId="Quantity"></AgGridColumn>
                                                                            <AgGridColumn width={230} field="PlantCode" headerName="Plant Code" cellClass={plantCodeCellClass} cellRenderer={'plantCodeFormatter'}></AgGridColumn>
                                                                            {RFQ_KEYS?.SHOW_HITRATEPERDAY_FIELD && <AgGridColumn width={230} field="HitRatePerDay" headerName="Hit Rate Per Day" cellClass={hitRateCellClass} cellRenderer={'hitRateFormatter'}></AgGridColumn>}
                                                                            {RFQ_KEYS?.SHOW_HITRATEPERDAY_FIELD && !isViewFlag && <AgGridColumn width={150} field="Actions" headerName="Actions" cellClass={actionsCellClass} cellRenderer={'actionsFormatter'}></AgGridColumn>}
                                                                        </AgGridReact>
                                                                    </div>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    );
                                                }

                                                // Show ONE combined table with ALL plants' data
                                                return (
                                                    <Row>
                                                        <Col md="12" className='ag-grid-react'>
                                                            <div className={`ag-grid-wrapper without-filter-grid rfq-grid height-width-wrapper`}>
                                                                <div className={`ag-theme-material`}>
                                                                    <AgGridReact
                                                                        defaultColDef={defaultColDef}
                                                                        floatingFilter={false}
                                                                        domLayout='autoHeight'
                                                                        rowData={sopQuantityList}
                                                                        onGridReady={onGridReady}
                                                                        onCellValueChanged={onCellValueChanged}
                                                                        gridOptions={gridOptionsPart}
                                                                        loadingOverlayComponent="customLoadingOverlay"
                                                                        noRowsOverlayComponent="customNoRowsOverlay"
                                                                        noRowsOverlayComponentParams={{
                                                                            title: EMPTY_DATA,
                                                                            imagClass: 'imagClass ',
                                                                            customClassName: "no-content-found"
                                                                        }}
                                                                        frameworkComponents={frameworkComponents}
                                                                        suppressRowTransform={true}
                                                                        suppressColumnVirtualisation={true}
                                                                        suppressHorizontalScroll={false}
                                                                        suppressColumnMoveAnimation={true}
                                                                    >
                                                                        <AgGridColumn width={230} field="PartNumber" headerName="Part No" tooltipField="PartNumber" cellClass={partNoCellClass} cellRenderer={'partNumberFormatter'}></AgGridColumn>
                                                                        <AgGridColumn width={230} field="YearName" headerName="Production Year" cellClass={separatorCellClass} cellRenderer={'sopFormatter'}></AgGridColumn>
                                                                        <AgGridColumn width={230} field="Quantity" headerName="Annual Forecast Quantity" cellClass={separatorCellClass} cellRenderer={'afcFormatter'} editable={EditableCallback} colId="Quantity"></AgGridColumn>
                                                                        <AgGridColumn width={230} field="PlantCode" headerName="Plant Code" cellClass={plantCodeCellClass} cellRenderer={'plantCodeFormatter'}></AgGridColumn>
                                                                        {RFQ_KEYS?.SHOW_HITRATEPERDAY_FIELD && <AgGridColumn width={230} field="HitRatePerDay" headerName="Hit Rate Per Day" cellClass={hitRateCellClass} cellRenderer={'hitRateFormatter'}></AgGridColumn>}
                                                                        {RFQ_KEYS?.SHOW_HITRATEPERDAY_FIELD && !isViewFlag && <AgGridColumn width={150} field="Actions" headerName="Actions" cellClass={actionsCellClass} cellRenderer={'actionsFormatter'}></AgGridColumn>}
                                                                    </AgGridReact>
                                                                </div>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                );
                                            })()}
                                        </div>
                                    </>)}
                            </Col>)}


                        {/* <Row> */}
                        {shouldShowButtons(Number(activeTab), props.partType) && (

                            <Row className="sf-btn-footer no-gutters justify-content-between">
                                <div className="col-md-12 pr-3">
                                    <div className="text-right">
                                        <Button
                                            id="rm-specification-cancel"
                                            className="mr-2"
                                            variant={"cancel-btn"}
                                            onClick={(e) => toggleDrawer(e)}
                                            icon={"cancel-icon"}
                                            buttonName={"Cancel"}
                                        />
                                        <Button
                                            id="rm-specification-submit"
                                            type="button"
                                            className="save-btn"
                                            icon="save-icon"
                                            onClick={handleSubmit(handleCloseDrawer)}
                                            buttonName={isEditFlag ? "Update" : "Save"}
                                            disabled={isViewFlag}
                                        />
                                    </div>
                                </div>
                            </Row>

                        )}

                    </div>
                </div>
            </Drawer>
        </>
    )
}
ViewDrawer.defaultProps = {
    type: null,
    isOpen: null,
    anchor: null,
    isEditFlag: null,
    isViewFlag: null,
    AssemblyPartNumber: null,
    tableData: null,
    setTableData: null,
    specificationList: null,
    setSpecificationList: null,
    setRemark: null,
    setChildPartFiles: null,
    remark: null,
    partListData: null,
    sopQuantityList: null,
    setSopQuantityList: null,
    sopdate: null,
    setSOPDate: null,
    effectiveMinDate: null,
    childPartFiles: null,
    rmSpecificRowData: null,
    partType: null,
    setViewQuotationPart: null
};

export default React.memo(ViewDrawer)